import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  SocialCamelJSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AllestimentoAutoNode = {
  __typename?: 'AllestimentoAutoNode';
  codice: Scalars['String']['output'];
  descrizione?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  quotazioneAuto?: Maybe<QuotazioneFastQuoteAutoNode>;
  selezionato: Scalars['Boolean']['output'];
};

export type AnimaleFastQuoteCasaNode = {
  __typename?: 'AnimaleFastQuoteCasaNode';
  created?: Maybe<Scalars['DateTime']['output']>;
  dataNascita?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  quotazioneCasa?: Maybe<QuotazioneFastQuoteCasaNode>;
  tipo?: Maybe<Scalars['String']['output']>;
};

export type AnimaleSalvaQuotazioneCasaFastInput = {
  dataNascita: Scalars['Date']['input'];
  nome: Scalars['String']['input'];
  tipo: Scalars['String']['input'];
};

export type ArticoloMagazineNode = Node & {
  __typename?: 'ArticoloMagazineNode';
  abstract?: Maybe<Scalars['String']['output']>;
  abstractIt?: Maybe<Scalars['String']['output']>;
  adminUrl?: Maybe<Scalars['String']['output']>;
  categoria?: Maybe<CategoriaArticoloNode>;
  categoriaArticolo?: Maybe<CategoriaArticoloNode>;
  contentTypeId?: Maybe<Scalars['Int']['output']>;
  correlati?: Maybe<Array<Maybe<ArticoloMagazineNode>>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  images: ImmagineMagazineNodeConnection;
  immagini?: Maybe<Array<Maybe<ImmagineMagazineNode>>>;
  mainImage?: Maybe<Scalars['String']['output']>;
  mainImageThumb?: Maybe<Scalars['String']['output']>;
  modelClass?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  next?: Maybe<ArticoloMagazineNode>;
  noindex: Scalars['Boolean']['output'];
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']['output']>;
  prev?: Maybe<ArticoloMagazineNode>;
  publicationDate?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoDescriptionIt?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  seoTitleIt?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  slugIt?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailBig?: Maybe<Scalars['String']['output']>;
  thumbnailSmall?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleIt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Array<Maybe<VideoMagazineNode>>>;
  videos: VideoMagazineNodeConnection;
  visibile?: Maybe<Scalars['Boolean']['output']>;
};


export type ArticoloMagazineNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ArticoloMagazineNodeVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ArticoloMagazineNodeConnection = {
  __typename?: 'ArticoloMagazineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ArticoloMagazineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ArticoloMagazineNode` and its cursor. */
export type ArticoloMagazineNodeEdge = {
  __typename?: 'ArticoloMagazineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ArticoloMagazineNode>;
};

export type BoxCategoriaNode = Node & {
  __typename?: 'BoxCategoriaNode';
  alias: Scalars['String']['output'];
  blank: Scalars['Boolean']['output'];
  categorie: CategoriaNodeConnection;
  /** Testo della CTA (se presente) */
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Testo della CTA (se presente) */
  ctaLabelIt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionIt?: Maybe<Scalars['String']['output']>;
  finalUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  /** Id di un elemento o paragrafo all'interno della pagina linkata */
  linkedAnchorId?: Maybe<Scalars['String']['output']>;
  linkedObjectId?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nameIt?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};


export type BoxCategoriaNodeCategorieArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BreadcrumbType = {
  __typename?: 'BreadcrumbType';
  titolo?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CalcolaCodiceFiscale = {
  __typename?: 'CalcolaCodiceFiscale';
  cf?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CalcolaCodiceFiscaleInput = {
  cognome: Scalars['String']['input'];
  dataNascita: Scalars['String']['input'];
  genere: Scalars['String']['input'];
  luogoNascita: Scalars['String']['input'];
  nome: Scalars['String']['input'];
};

export type CampoQuotazioneFastQuoteAutoNode = {
  __typename?: 'CampoQuotazioneFastQuoteAutoNode';
  nome?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CategoriaArticoloNode = Node & {
  __typename?: 'CategoriaArticoloNode';
  articoliMagazine: ArticoloMagazineNodeConnection;
  created?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  noindex: Scalars['Boolean']['output'];
  numArticoli?: Maybe<Scalars['Int']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoDescriptionIt?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  seoTitleIt?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugIt?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleIt?: Maybe<Scalars['String']['output']>;
};


export type CategoriaArticoloNodeArticoliMagazineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_Equals?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_In?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CategoriaArticoloNodeConnection = {
  __typename?: 'CategoriaArticoloNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaArticoloNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoriaArticoloNode` and its cursor. */
export type CategoriaArticoloNodeEdge = {
  __typename?: 'CategoriaArticoloNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CategoriaArticoloNode>;
};

export type CategoriaFaqNode = Node & {
  __typename?: 'CategoriaFaqNode';
  alias?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  descrizioneIt?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<Array<Maybe<FaqNode>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  ordine: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  slugIt?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  titolo?: Maybe<Scalars['String']['output']>;
  titoloIt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CategoriaFaqNodeConnection = {
  __typename?: 'CategoriaFaqNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaFaqNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoriaFaqNode` and its cursor. */
export type CategoriaFaqNodeEdge = {
  __typename?: 'CategoriaFaqNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CategoriaFaqNode>;
};

export type CategoriaFascicoloNode = Node & {
  __typename?: 'CategoriaFascicoloNode';
  alias: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  fascicoli: FascicoloNodeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  nome: Scalars['String']['output'];
  nomeIt?: Maybe<Scalars['String']['output']>;
  numFascicoli?: Maybe<Scalars['Int']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  slugIt?: Maybe<Scalars['String']['output']>;
};


export type CategoriaFascicoloNodeFascicoliArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_Equals?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_In?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  titolo?: InputMaybe<Scalars['String']['input']>;
  titolo_Icontains?: InputMaybe<Scalars['String']['input']>;
};

export type CategoriaFascicoloNodeConnection = {
  __typename?: 'CategoriaFascicoloNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaFascicoloNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoriaFascicoloNode` and its cursor. */
export type CategoriaFascicoloNodeEdge = {
  __typename?: 'CategoriaFascicoloNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CategoriaFascicoloNode>;
};

export type CategoriaFondoNode = Node & {
  __typename?: 'CategoriaFondoNode';
  created?: Maybe<Scalars['DateTime']['output']>;
  fondi?: Maybe<Array<Maybe<FondoNode>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  nome: Scalars['String']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
};

export type CategoriaFondoNodeConnection = {
  __typename?: 'CategoriaFondoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaFondoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoriaFondoNode` and its cursor. */
export type CategoriaFondoNodeEdge = {
  __typename?: 'CategoriaFondoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CategoriaFondoNode>;
};

export type CategoriaNode = Node & {
  __typename?: 'CategoriaNode';
  adminUrl?: Maybe<Scalars['String']['output']>;
  box?: Maybe<BoxCategoriaNode>;
  children: CategoriaNodeConnection;
  codice: Scalars['String']['output'];
  contentTypeId?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  descrizioneAggiuntiva?: Maybe<Scalars['String']['output']>;
  descrizioneAggiuntivaIt?: Maybe<Scalars['String']['output']>;
  descrizioneIt?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  level: Scalars['Int']['output'];
  lft: Scalars['Int']['output'];
  mainImage?: Maybe<Scalars['String']['output']>;
  modelClass?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  noindex: Scalars['Boolean']['output'];
  nome: Scalars['String']['output'];
  nomeIt?: Maybe<Scalars['String']['output']>;
  pagina?: Maybe<PaginaNode>;
  parent?: Maybe<CategoriaNode>;
  pk?: Maybe<Scalars['Int']['output']>;
  previewImage?: Maybe<Scalars['String']['output']>;
  prodotti?: Maybe<Array<Maybe<ProdottoNode>>>;
  pubblicato?: Maybe<Scalars['Boolean']['output']>;
  rght: Scalars['Int']['output'];
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoDescriptionIt?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  seoTitleIt?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  slugIt?: Maybe<Scalars['String']['output']>;
  slugTree?: Maybe<Scalars['String']['output']>;
  slugTreeIt?: Maybe<Scalars['String']['output']>;
  statoPubblicazione: CategorieCategoriaStatoPubblicazioneChoices;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
  treeId: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  visibile?: Maybe<Scalars['Boolean']['output']>;
  /** Data e ora fino a quando sarà visibile il contenuto (non obbligatorio) */
  visibilitaAl?: Maybe<Scalars['DateTime']['output']>;
  /** Data e ora da quando sarà visibile il contenuto (non obbligatorio) */
  visibilitaDal?: Maybe<Scalars['DateTime']['output']>;
};


export type CategoriaNodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoriaNodeConnection = {
  __typename?: 'CategoriaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CategoriaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CategoriaNode` and its cursor. */
export type CategoriaNodeEdge = {
  __typename?: 'CategoriaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<CategoriaNode>;
};

/** An enumeration. */
export enum CategorieCategoriaStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type CreateRichiestaContatto = {
  __typename?: 'CreateRichiestaContatto';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateRichiestaPreventivatore = {
  __typename?: 'CreateRichiestaPreventivatore';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type FaqNode = Node & {
  __typename?: 'FaqNode';
  categoria: CategoriaFaqNode;
  created?: Maybe<Scalars['DateTime']['output']>;
  domanda: Scalars['String']['output'];
  domandaIt?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  ordine: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  risposta?: Maybe<Scalars['String']['output']>;
  rispostaIt?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  slugIt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FaqNodeConnection = {
  __typename?: 'FaqNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FaqNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FaqNode` and its cursor. */
export type FaqNodeEdge = {
  __typename?: 'FaqNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FaqNode>;
};

export type FaqProdottoNode = Node & {
  __typename?: 'FaqProdottoNode';
  created?: Maybe<Scalars['DateTime']['output']>;
  domanda: Scalars['String']['output'];
  domandaIt?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  ordinamento: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  prodotti: ProdottoNodeConnection;
  risposta?: Maybe<Scalars['String']['output']>;
  rispostaIt?: Maybe<Scalars['String']['output']>;
};


export type FaqProdottoNodeProdottiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type FascicoloFileNode = Node & {
  __typename?: 'FascicoloFileNode';
  fascicolo: FascicoloNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  ordinamento: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FascicoloNode = Node & {
  __typename?: 'FascicoloNode';
  alias: Scalars['String']['output'];
  attivo: Scalars['Boolean']['output'];
  categoria?: Maybe<CategoriaFascicoloNode>;
  created?: Maybe<Scalars['DateTime']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  descrizioneIt?: Maybe<Scalars['String']['output']>;
  /** Il giorno non sarà considerato */
  edizione?: Maybe<Scalars['Date']['output']>;
  files?: Maybe<Array<Maybe<FascicoloFileNode>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<TagFascicoloNode>>>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FascicoloNodeConnection = {
  __typename?: 'FascicoloNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FascicoloNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FascicoloNode` and its cursor. */
export type FascicoloNodeEdge = {
  __typename?: 'FascicoloNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FascicoloNode>;
};

/** An enumeration. */
export enum FastquoteTipologiaCampoCasaCampoChoices {
  /** Abitazione */
  Abitazione = 'ABITAZIONE',
  /** Proprietà */
  Proprieta = 'PROPRIETA',
  /** Residenza */
  Residenza = 'RESIDENZA'
}

export type FondoCatalogoNode = Node & {
  __typename?: 'FondoCatalogoNode';
  alias: Scalars['String']['output'];
  attivo: Scalars['Boolean']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  descrizioneIt?: Maybe<Scalars['String']['output']>;
  /** Il giorno non sarà considerato */
  edizione?: Maybe<Scalars['Date']['output']>;
  files?: Maybe<Array<Maybe<FondoFileNode>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<TagFondoNode>>>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
};

export type FondoCatalogoNodeConnection = {
  __typename?: 'FondoCatalogoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FondoCatalogoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FondoCatalogoNode` and its cursor. */
export type FondoCatalogoNodeEdge = {
  __typename?: 'FondoCatalogoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FondoCatalogoNode>;
};

export type FondoFileNode = Node & {
  __typename?: 'FondoFileNode';
  fondo: FondoCatalogoNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  ordinamento: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type FondoNode = Node & {
  __typename?: 'FondoNode';
  categorie: CategoriaFondoNodeConnection;
  codiceCompagnia: Scalars['Int']['output'];
  codiceFondo: Scalars['String']['output'];
  codiceIsin?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  descrizioneCompleta: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  prospettoFile?: Maybe<Scalars['String']['output']>;
  prospettoUrl?: Maybe<Scalars['String']['output']>;
  tipologia?: Maybe<Scalars['String']['output']>;
  valoreQuota?: Maybe<ValoreQuotaNode>;
  valoriQuota: ValoreQuotaNodeConnection;
};


export type FondoNodeCategorieArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type FondoNodeValoriQuotaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type FondoNodeConnection = {
  __typename?: 'FondoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FondoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `FondoNode` and its cursor. */
export type FondoNodeEdge = {
  __typename?: 'FondoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<FondoNode>;
};

export type GaranziaFastQuoteAutoNode = {
  __typename?: 'GaranziaFastQuoteAutoNode';
  children?: Maybe<Array<Maybe<GaranziaFastQuoteAutoNode>>>;
  codice?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  descrizioneAggiuntiva?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  franchigia?: Maybe<Scalars['String']['output']>;
  franchigiaDesc?: Maybe<Scalars['String']['output']>;
  garanzieAbbinate?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  garanzieEscluse?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  garanzieNecessariePacchettoEventi?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  garanzieNecessariePacchettoPersona?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  garanzieNecessariePacchettoVeicolo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importoLordoAnnuo?: Maybe<Scalars['Float']['output']>;
  importoLordoAnnuoScontato?: Maybe<Scalars['Float']['output']>;
  keyPremio?: Maybe<Scalars['String']['output']>;
  massimale?: Maybe<Scalars['Float']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  pacchetto?: Maybe<PacchettoGaranziaFastQuoteAutoNode>;
  parent?: Maybe<GaranziaFastQuoteAutoNode>;
  pk?: Maybe<Scalars['Int']['output']>;
  premioLordoAnnuo?: Maybe<Scalars['Float']['output']>;
  quotazioneAuto?: Maybe<QuotazioneFastQuoteAutoNode>;
  scontoBlackbox: Scalars['Float']['output'];
  scontoTerritoriale: Scalars['Float']['output'];
  selezionata: Scalars['Boolean']['output'];
  statoIniziale?: Maybe<Scalars['String']['output']>;
  titolo?: Maybe<Scalars['String']['output']>;
};

export type GaranziaFastQuoteCasaNode = {
  __typename?: 'GaranziaFastQuoteCasaNode';
  children?: Maybe<Array<Maybe<GaranziaFastQuoteCasaNode>>>;
  codice?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  descrizioneAggiuntiva?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  franchigia?: Maybe<Scalars['String']['output']>;
  franchigiaDesc?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importoLordoAnnuo?: Maybe<Scalars['Float']['output']>;
  keyMassimale?: Maybe<Scalars['Float']['output']>;
  massimale?: Maybe<Scalars['Float']['output']>;
  massimaleDesc?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  parent?: Maybe<GaranziaFastQuoteCasaNode>;
  pk?: Maybe<Scalars['Int']['output']>;
  premioLordoAnnuo?: Maybe<Scalars['Float']['output']>;
  premioLordoMensile?: Maybe<Scalars['Float']['output']>;
  quotazioneCasa?: Maybe<QuotazioneFastQuoteCasaNode>;
  selezionata: Scalars['Boolean']['output'];
  tipo?: Maybe<Scalars['String']['output']>;
  titolo?: Maybe<Scalars['String']['output']>;
};

export type GaranziaLineaNode = Node & {
  __typename?: 'GaranziaLineaNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['String']['output']>;
  infoIt?: Maybe<Scalars['String']['output']>;
  linee: LineaNodeConnection;
  pk?: Maybe<Scalars['Int']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  tipologia: ProdottiGaranziaLineaTipologiaChoices;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
};


export type GaranziaLineaNodeLineeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GaranziaLineaNodeConnection = {
  __typename?: 'GaranziaLineaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<GaranziaLineaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GaranziaLineaNode` and its cursor. */
export type GaranziaLineaNodeEdge = {
  __typename?: 'GaranziaLineaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GaranziaLineaNode>;
};

export type GetPremioAutoFast = {
  __typename?: 'GetPremioAutoFast';
  hash?: Maybe<Scalars['String']['output']>;
  inputError?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  quotazione?: Maybe<QuotazioneFastQuoteAutoNode>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type GetPremioAutoFastInput = {
  allestimentoCodice?: InputMaybe<Scalars['String']['input']>;
  antifurto?: InputMaybe<Scalars['String']['input']>;
  cap?: InputMaybe<Scalars['String']['input']>;
  consensoTrattamento?: InputMaybe<Scalars['String']['input']>;
  dataDecorrenza?: InputMaybe<Scalars['Date']['input']>;
  dataNascita?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  massimaleCristalli?: InputMaybe<Scalars['String']['input']>;
  massimaleRca?: InputMaybe<Scalars['String']['input']>;
  sistemaAdas?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  targa?: InputMaybe<Scalars['String']['input']>;
  tipoGuida?: InputMaybe<Scalars['String']['input']>;
};

export type GetPremioCasaFast = {
  __typename?: 'GetPremioCasaFast';
  hash?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  quotazione?: Maybe<QuotazioneFastQuoteCasaNode>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type GetPremioCasaFastInput = {
  altraCopMutuo?: InputMaybe<Scalars['String']['input']>;
  cap?: InputMaybe<Scalars['String']['input']>;
  consensoTrattamento?: InputMaybe<Scalars['String']['input']>;
  dataDecorrenza?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  metriQuadrati?: InputMaybe<Scalars['Int']['input']>;
  piano?: InputMaybe<Scalars['Int']['input']>;
  proprieta?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  tipoAbitazione?: InputMaybe<Scalars['String']['input']>;
  tipoResidenza?: InputMaybe<Scalars['String']['input']>;
  valArredamento?: InputMaybe<Scalars['String']['input']>;
};

export type ImmagineMagazineNode = Node & {
  __typename?: 'ImmagineMagazineNode';
  articolo: ArticoloMagazineNode;
  created?: Maybe<Scalars['DateTime']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  order: Scalars['Int']['output'];
};

export type ImmagineMagazineNodeConnection = {
  __typename?: 'ImmagineMagazineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ImmagineMagazineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ImmagineMagazineNode` and its cursor. */
export type ImmagineMagazineNodeEdge = {
  __typename?: 'ImmagineMagazineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ImmagineMagazineNode>;
};

export type LineaNode = Node & {
  __typename?: 'LineaNode';
  created?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionIt?: Maybe<Scalars['String']['output']>;
  descrizioneBreve?: Maybe<Scalars['String']['output']>;
  descrizioneBreveIt?: Maybe<Scalars['String']['output']>;
  garanzie: GaranziaLineaNodeConnection;
  garanzieIncluse?: Maybe<Array<Maybe<GaranziaLineaNode>>>;
  garanzieOpzionali?: Maybe<Array<Maybe<GaranziaLineaNode>>>;
  icon?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inPreventivatore: Scalars['Boolean']['output'];
  label?: Maybe<Scalars['String']['output']>;
  labelIt?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  ordinamento: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  /** Costo della linea per mese */
  prezzo?: Maybe<Scalars['Float']['output']>;
  prodotti: ProdottoNodeConnection;
  style?: Maybe<Scalars['String']['output']>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
};


export type LineaNodeGaranzieArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LineaNodeProdottiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LineaNodeConnection = {
  __typename?: 'LineaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LineaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LineaNode` and its cursor. */
export type LineaNodeEdge = {
  __typename?: 'LineaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LineaNode>;
};

/** An enumeration. */
export enum MagazineVideoItemTipoVideoChoices {
  /** Vimeo */
  A_0 = 'A_0',
  /** Youtube */
  A_1 = 'A_1'
}

export type MenuItemNode = Node & {
  __typename?: 'MenuItemNode';
  alias?: Maybe<Scalars['String']['output']>;
  attivo?: Maybe<Scalars['Boolean']['output']>;
  blank: Scalars['Boolean']['output'];
  chatbotUrl?: Maybe<Scalars['String']['output']>;
  children?: Maybe<MenuItemNodeConnection>;
  /** Testo della CTA (se presente) */
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Testo della CTA (se presente) */
  ctaLabelIt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionIt?: Maybe<Scalars['String']['output']>;
  finalUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  lft: Scalars['Int']['output'];
  /** Id di un elemento o paragrafo all'interno della pagina linkata */
  linkedAnchorId?: Maybe<Scalars['String']['output']>;
  linkedObjectId?: Maybe<Scalars['Int']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  mainImageResponsive?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameIt?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<MenuItemNode>;
  pk?: Maybe<Scalars['Int']['output']>;
  prodottoCollegato?: Maybe<ProdottoNode>;
  rght: Scalars['Int']['output'];
  secondaryImage?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  treeId: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


export type MenuItemNodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  attivo?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  parent_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MenuItemNodeConnection = {
  __typename?: 'MenuItemNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MenuItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `MenuItemNode` and its cursor. */
export type MenuItemNodeEdge = {
  __typename?: 'MenuItemNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<MenuItemNode>;
};

/** An enumeration. */
export enum Modello {
  Articolomagazine = 'articolomagazine',
  Categoria = 'categoria',
  Faq = 'faq',
  Fascicolo = 'fascicolo',
  Pagina = 'pagina',
  Prodotto = 'prodotto'
}

export type Mutation = {
  __typename?: 'Mutation';
  calcolaCodiceFiscale?: Maybe<CalcolaCodiceFiscale>;
  createRichiestaContatto?: Maybe<CreateRichiestaContatto>;
  createRichiestaPreventivatore?: Maybe<CreateRichiestaPreventivatore>;
  getPremioAutoFast?: Maybe<GetPremioAutoFast>;
  getPremioCasaFast?: Maybe<GetPremioCasaFast>;
  salvaQuotazioneCasaFast?: Maybe<SalvaQuotazioneCasaFast>;
  salvaTrasformaQuotazioneAutoFast?: Maybe<SalvaTrasformaQuotazioneAutoFast>;
  salvaTrasformaQuotazioneCasaFast?: Maybe<SalvaTrasformaQuotazioneCasaFast>;
  trasformaQuotazioneCasaFast?: Maybe<TrasformaQuotazioneCasaFast>;
};


export type MutationCalcolaCodiceFiscaleArgs = {
  input: CalcolaCodiceFiscaleInput;
};


export type MutationCreateRichiestaContattoArgs = {
  input: RichiestaContattoInput;
};


export type MutationCreateRichiestaPreventivatoreArgs = {
  input: RichiestaPreventivatoreInput;
};


export type MutationGetPremioAutoFastArgs = {
  input: GetPremioAutoFastInput;
};


export type MutationGetPremioCasaFastArgs = {
  input: GetPremioCasaFastInput;
};


export type MutationSalvaQuotazioneCasaFastArgs = {
  input: SalvaQuotazioneCasaFastInput;
};


export type MutationSalvaTrasformaQuotazioneAutoFastArgs = {
  input: SalvaTrasformaQuotazioneAutoFastInput;
};


export type MutationSalvaTrasformaQuotazioneCasaFastArgs = {
  input: SalvaTrasformaQuotazioneCasaFastInput;
};


export type MutationTrasformaQuotazioneCasaFastArgs = {
  input: TrasformaQuotazioneCasaFastInput;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type PacchettoGaranziaFastQuoteAutoNode = {
  __typename?: 'PacchettoGaranziaFastQuoteAutoNode';
  codice: Scalars['String']['output'];
  descrizione?: Maybe<Scalars['String']['output']>;
  garanzie: Array<GaranziaFastQuoteAutoNode>;
  id: Scalars['ID']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  titolo?: Maybe<Scalars['String']['output']>;
  titoloIt?: Maybe<Scalars['String']['output']>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum PagesPaginaStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

/** An enumeration. */
export enum PagesPaginaTemplateChoices {
  /** Default */
  Default = 'DEFAULT'
}

/** An enumeration. */
export enum PagesPaginaTipologiaChoices {
  /** Pagina */
  Page = 'PAGE',
  /** Pagina applicazione */
  PageApp = 'PAGE_APP',
  /** Pagine Entità */
  PageAppMany = 'PAGE_APP_MANY'
}

export type PaginaNode = Node & {
  __typename?: 'PaginaNode';
  adminUrl?: Maybe<Scalars['String']['output']>;
  breadcrumbs?: Maybe<Array<Maybe<BreadcrumbType>>>;
  chiave?: Maybe<Scalars['String']['output']>;
  chiaveMenu?: Maybe<Scalars['String']['output']>;
  children: PaginaNodeConnection;
  contentTypeId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  cta?: Maybe<Scalars['String']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  descrizioneIt?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inRicerca: Scalars['Boolean']['output'];
  inSitemap: Scalars['Boolean']['output'];
  level: Scalars['Int']['output'];
  lft: Scalars['Int']['output'];
  linkEsterno?: Maybe<Scalars['String']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  noindex: Scalars['Boolean']['output'];
  nome?: Maybe<Scalars['String']['output']>;
  nomeIt?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<PaginaNode>;
  path?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  previewImage?: Maybe<Scalars['String']['output']>;
  pubblicato?: Maybe<Scalars['Boolean']['output']>;
  rght: Scalars['Int']['output'];
  seo?: Maybe<SeoType>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoDescriptionIt?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  seoTitleIt?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  slugIt?: Maybe<Scalars['String']['output']>;
  statoPubblicazione: PagesPaginaStatoPubblicazioneChoices;
  template: PagesPaginaTemplateChoices;
  tipologia: PagesPaginaTipologiaChoices;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
  treeId: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
  visibile?: Maybe<Scalars['Boolean']['output']>;
  visibilitaAl?: Maybe<Scalars['String']['output']>;
  visibilitaDal?: Maybe<Scalars['String']['output']>;
};


export type PaginaNodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginaNodeConnection = {
  __typename?: 'PaginaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaginaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaginaNode` and its cursor. */
export type PaginaNodeEdge = {
  __typename?: 'PaginaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PaginaNode>;
};

/** An enumeration. */
export enum ProdottiGaranziaLineaTipologiaChoices {
  /** Inclusa */
  Inclusa = 'INCLUSA',
  /** Opzionale */
  Opzionale = 'OPZIONALE'
}

/** An enumeration. */
export enum ProdottiProdottoStatoPubblicazioneChoices {
  /** Non Pubblicato */
  Nopubblicato = 'NOPUBBLICATO',
  /** Pubblicato */
  Pubblicato = 'PUBBLICATO'
}

export type ProdottoMenuItemNode = Node & {
  __typename?: 'ProdottoMenuItemNode';
  alias?: Maybe<Scalars['String']['output']>;
  attivo?: Maybe<Scalars['Boolean']['output']>;
  blank?: Maybe<Scalars['Boolean']['output']>;
  children: ProdottoMenuItemNodeConnection;
  /** Testo della CTA (se presente) */
  ctaLabel?: Maybe<Scalars['String']['output']>;
  /** Testo della CTA (se presente) */
  ctaLabelIt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionIt?: Maybe<Scalars['String']['output']>;
  finalUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  lft: Scalars['Int']['output'];
  /** Id di un elemento o paragrafo all'interno della pagina linkata */
  linkedAnchorId?: Maybe<Scalars['String']['output']>;
  linkedObjectId?: Maybe<Scalars['Int']['output']>;
  mainImage?: Maybe<Scalars['String']['output']>;
  mainImageResponsive?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameIt?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ProdottoMenuItemNode>;
  pk?: Maybe<Scalars['Int']['output']>;
  prodotti: ProdottoNodeConnection;
  rght: Scalars['Int']['output'];
  secondaryImage?: Maybe<Scalars['String']['output']>;
  style?: Maybe<Scalars['String']['output']>;
  treeId: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


export type ProdottoMenuItemNodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  attivo?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  parent_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProdottoMenuItemNodeProdottiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProdottoMenuItemNodeConnection = {
  __typename?: 'ProdottoMenuItemNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProdottoMenuItemNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProdottoMenuItemNode` and its cursor. */
export type ProdottoMenuItemNodeEdge = {
  __typename?: 'ProdottoMenuItemNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProdottoMenuItemNode>;
};

export type ProdottoNode = Node & {
  __typename?: 'ProdottoNode';
  adminUrl?: Maybe<Scalars['String']['output']>;
  categoria?: Maybe<CategoriaNode>;
  contentTypeId?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  descrizione?: Maybe<Scalars['String']['output']>;
  descrizioneBreve?: Maybe<Scalars['String']['output']>;
  descrizioneBreveIt?: Maybe<Scalars['String']['output']>;
  descrizioneIt?: Maybe<Scalars['String']['output']>;
  faqs?: Maybe<Array<Maybe<FaqProdottoNode>>>;
  icon?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  linee?: Maybe<Array<Maybe<LineaNode>>>;
  mainImage?: Maybe<Scalars['String']['output']>;
  menuItems?: Maybe<ProdottoMenuItemNode>;
  modelClass?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  noindex: Scalars['Boolean']['output'];
  pagina?: Maybe<PaginaNode>;
  pk?: Maybe<Scalars['Int']['output']>;
  /** Indica se il preventivatore è abilitato o meno per questo prodotto */
  preventivatore: Scalars['Boolean']['output'];
  previewImage?: Maybe<Scalars['String']['output']>;
  prodotti: ProdottoNodeConnection;
  prodottiCorrelati: ProdottoNodeConnection;
  pubblicato?: Maybe<Scalars['Boolean']['output']>;
  sconto?: Maybe<Scalars['String']['output']>;
  scontoIt?: Maybe<Scalars['String']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoDescriptionIt?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  seoTitleIt?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  slugIt?: Maybe<Scalars['String']['output']>;
  statoPubblicazione: ProdottiProdottoStatoPubblicazioneChoices;
  tags?: Maybe<Array<Maybe<TagProdottoNode>>>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  visibile?: Maybe<Scalars['Boolean']['output']>;
  /** Data e ora fino a quando sarà visibile il contenuto (non obbligatorio) */
  visibilitaAl?: Maybe<Scalars['DateTime']['output']>;
  /** Data e ora da quando sarà visibile il contenuto (non obbligatorio) */
  visibilitaDal?: Maybe<Scalars['DateTime']['output']>;
};


export type ProdottoNodeProdottiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ProdottoNodeProdottiCorrelatiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProdottoNodeConnection = {
  __typename?: 'ProdottoNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProdottoNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProdottoNode` and its cursor. */
export type ProdottoNodeEdge = {
  __typename?: 'ProdottoNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProdottoNode>;
};

export type Query = {
  __typename?: 'Query';
  articoliMagazine?: Maybe<ArticoloMagazineNodeConnection>;
  articoloMagazine?: Maybe<ArticoloMagazineNode>;
  catalogoFondi?: Maybe<FondoCatalogoNodeConnection>;
  categoria?: Maybe<CategoriaNode>;
  categoriaFaq?: Maybe<CategoriaFaqNode>;
  categorie?: Maybe<CategoriaNodeConnection>;
  categorieArticoli?: Maybe<CategoriaArticoloNodeConnection>;
  categorieFaq?: Maybe<CategoriaFaqNodeConnection>;
  categorieFascicoli?: Maybe<CategoriaFascicoloNodeConnection>;
  categorieFondo?: Maybe<CategoriaFondoNodeConnection>;
  faq?: Maybe<FaqNodeConnection>;
  fascicoli?: Maybe<FascicoloNodeConnection>;
  fondi?: Maybe<FondoNodeConnection>;
  me?: Maybe<UtenteNode>;
  menuitem?: Maybe<MenuItemNode>;
  menuitems?: Maybe<MenuItemNodeConnection>;
  pagina?: Maybe<PaginaNode>;
  pagine?: Maybe<PaginaNodeConnection>;
  prodotti?: Maybe<ProdottoNodeConnection>;
  prodottiPreventivatore?: Maybe<ProdottoNodeConnection>;
  prodotto?: Maybe<ProdottoNode>;
  quotazioneAuto?: Maybe<QuotazioneFastQuoteAutoNode>;
  quotazioneCasa?: Maybe<QuotazioneFastQuoteCasaNode>;
  search?: Maybe<SearchConnection>;
  tipologieAbitazione?: Maybe<Array<Maybe<TipologiaCampoCasaNode>>>;
  tipologieContatto?: Maybe<Array<Maybe<TipologiaContattoNode>>>;
  tipologieProprieta?: Maybe<Array<Maybe<TipologiaCampoCasaNode>>>;
  tipologieResidenza?: Maybe<Array<Maybe<TipologiaCampoCasaNode>>>;
};


export type QueryArticoliMagazineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_Equals?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_In?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArticoloMagazineArgs = {
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryCatalogoFondiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  titolo?: InputMaybe<Scalars['String']['input']>;
  titolo_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoriaArgs = {
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  slugTree: Scalars['String']['input'];
};


export type QueryCategoriaFaqArgs = {
  slug: Scalars['String']['input'];
};


export type QueryCategorieArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategorieArticoliArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategorieFaqArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategorieFascicoliArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategorieFondoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFaqArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFascicoliArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_Equals?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_In?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  titolo?: InputMaybe<Scalars['String']['input']>;
  titolo_Icontains?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFondiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categorie_Slug_Equals?: InputMaybe<Scalars['String']['input']>;
  categorie_Slug_In?: InputMaybe<Scalars['String']['input']>;
  descrizioneCompleta?: InputMaybe<Scalars['String']['input']>;
  descrizioneCompleta_Icontains?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tipologia?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuitemArgs = {
  alias?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMenuitemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  attivo?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  parent_Isnull?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPaginaArgs = {
  chiave?: InputMaybe<Scalars['String']['input']>;
  contentTypeId?: InputMaybe<Scalars['Int']['input']>;
  objectId?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPagineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProdottiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProdottiPreventivatoreArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProdottoArgs = {
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryQuotazioneAutoArgs = {
  hashKey?: InputMaybe<Scalars['String']['input']>;
  idQuotazione: Scalars['String']['input'];
  resetSession?: InputMaybe<Scalars['Boolean']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryQuotazioneCasaArgs = {
  hashKey?: InputMaybe<Scalars['String']['input']>;
  idQuotazione: Scalars['String']['input'];
  resetSession?: InputMaybe<Scalars['Boolean']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  models?: InputMaybe<Array<InputMaybe<Modello>>>;
  query: Scalars['String']['input'];
};

export type QuotazioneFastQuoteAutoNode = {
  __typename?: 'QuotazioneFastQuoteAutoNode';
  allestimentiAuto?: Maybe<Array<Maybe<AllestimentoAutoNode>>>;
  allestimentoCodice?: Maybe<Scalars['String']['output']>;
  allestimentoDescrizione?: Maybe<Scalars['String']['output']>;
  antifurto?: Maybe<Scalars['String']['output']>;
  campiAntifurto?: Maybe<Array<Maybe<CampoQuotazioneFastQuoteAutoNode>>>;
  campiSistemaAdas?: Maybe<Array<Maybe<CampoQuotazioneFastQuoteAutoNode>>>;
  campiTipoGuida?: Maybe<Array<Maybe<CampoQuotazioneFastQuoteAutoNode>>>;
  cap?: Maybe<Scalars['String']['output']>;
  cf?: Maybe<Scalars['String']['output']>;
  codContratto?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  completata?: Maybe<Scalars['Boolean']['output']>;
  consensoTrattamento?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  dataDecorrenza?: Maybe<Scalars['Date']['output']>;
  dataNascita: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  errore: Scalars['Boolean']['output'];
  erroreMsg?: Maybe<Scalars['String']['output']>;
  garanzie?: Maybe<Array<Maybe<GaranziaFastQuoteAutoNode>>>;
  garanzieSelezionate?: Maybe<Array<Maybe<GaranziaFastQuoteAutoNode>>>;
  id: Scalars['ID']['output'];
  idQuotazione?: Maybe<Scalars['String']['output']>;
  importoLordoAnnuo?: Maybe<Scalars['Float']['output']>;
  importoLordoAnnuoScontato?: Maybe<Scalars['Float']['output']>;
  isCliente?: Maybe<Scalars['Boolean']['output']>;
  listaCap?: Maybe<Scalars['String']['output']>;
  marcaAuto?: Maybe<Scalars['String']['output']>;
  massimaleCristalli?: Maybe<Scalars['String']['output']>;
  massimaleRca?: Maybe<Scalars['String']['output']>;
  modelloAuto?: Maybe<Scalars['String']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  ndg?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pacchetti?: Maybe<Array<Maybe<PacchettoGaranziaFastQuoteAutoNode>>>;
  pk?: Maybe<Scalars['Int']['output']>;
  prodotto?: Maybe<ProdottoNode>;
  scontoPacchettoEventi?: Maybe<Scalars['Float']['output']>;
  scontoPacchettoPersona?: Maybe<Scalars['Float']['output']>;
  scontoPacchettoPersonaEventi?: Maybe<Scalars['Float']['output']>;
  scontoPacchettoPersonaVeicolo?: Maybe<Scalars['Float']['output']>;
  scontoPacchettoPersonaVeicoloEventi?: Maybe<Scalars['Float']['output']>;
  scontoPacchettoVeicolo?: Maybe<Scalars['Float']['output']>;
  scontoPacchettoVeicoloEventi?: Maybe<Scalars['Float']['output']>;
  sistemaAdas?: Maybe<Scalars['String']['output']>;
  targa: Scalars['String']['output'];
  telefono?: Maybe<Scalars['String']['output']>;
  tipoGuida?: Maybe<Scalars['String']['output']>;
};

export type QuotazioneFastQuoteCasaNode = {
  __typename?: 'QuotazioneFastQuoteCasaNode';
  altraCopMutuo?: Maybe<Scalars['String']['output']>;
  animali?: Maybe<Array<Maybe<AnimaleFastQuoteCasaNode>>>;
  cap?: Maybe<Scalars['String']['output']>;
  cf?: Maybe<Scalars['String']['output']>;
  codContratto?: Maybe<Scalars['String']['output']>;
  cognome?: Maybe<Scalars['String']['output']>;
  completata?: Maybe<Scalars['Boolean']['output']>;
  consensoTrattamento?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  dataDecorrenza?: Maybe<Scalars['Date']['output']>;
  email: Scalars['String']['output'];
  errore: Scalars['Boolean']['output'];
  erroreMsg?: Maybe<Scalars['String']['output']>;
  etaMassimaCane?: Maybe<Scalars['Int']['output']>;
  etaMassimaGatto?: Maybe<Scalars['Int']['output']>;
  etaMinimaCane?: Maybe<Scalars['Int']['output']>;
  etaMinimaGatto?: Maybe<Scalars['Int']['output']>;
  garanzie?: Maybe<Array<Maybe<GaranziaFastQuoteCasaNode>>>;
  garanzieSelezionate?: Maybe<Array<Maybe<GaranziaFastQuoteCasaNode>>>;
  id: Scalars['ID']['output'];
  idQuotazione?: Maybe<Scalars['String']['output']>;
  importoLordoAnnuo?: Maybe<Scalars['Float']['output']>;
  isCliente?: Maybe<Scalars['Boolean']['output']>;
  metriQuadrati?: Maybe<Scalars['Int']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  ndg?: Maybe<Scalars['String']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  piano?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  prodotto?: Maybe<ProdottoNode>;
  proprieta?: Maybe<Scalars['String']['output']>;
  telefono?: Maybe<Scalars['String']['output']>;
  tipoAbitazione?: Maybe<Scalars['String']['output']>;
  tipoResidenza?: Maybe<Scalars['String']['output']>;
  valArredamento?: Maybe<Scalars['String']['output']>;
};

export type RichiestaContattoInput = {
  allegati?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  captcha: Scalars['String']['input'];
  cf?: InputMaybe<Scalars['String']['input']>;
  cognome?: InputMaybe<Scalars['String']['input']>;
  documento?: InputMaybe<Scalars['Upload']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  messaggio?: InputMaybe<Scalars['String']['input']>;
  nome?: InputMaybe<Scalars['String']['input']>;
  numeroPolizza?: InputMaybe<Scalars['String']['input']>;
  privacy: Scalars['Boolean']['input'];
  telefono?: InputMaybe<Scalars['String']['input']>;
  tipologia?: InputMaybe<Scalars['String']['input']>;
};

export type RichiestaPreventivatoreInput = {
  captcha: Scalars['String']['input'];
  cognome: Scalars['String']['input'];
  email: Scalars['String']['input'];
  lineeIds: Array<InputMaybe<Scalars['Int']['input']>>;
  nome: Scalars['String']['input'];
  privacy: Scalars['Boolean']['input'];
  prodottoId: Scalars['Int']['input'];
  quotazioneAutoId?: InputMaybe<Scalars['Int']['input']>;
  quotazioneCasaId?: InputMaybe<Scalars['Int']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  telefono: Scalars['String']['input'];
};

export type SalvaQuotazioneCasaFast = {
  __typename?: 'SalvaQuotazioneCasaFast';
  message?: Maybe<Scalars['String']['output']>;
  quotazione?: Maybe<QuotazioneFastQuoteCasaNode>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type SalvaQuotazioneCasaFastInput = {
  animali?: InputMaybe<Array<InputMaybe<AnimaleSalvaQuotazioneCasaFastInput>>>;
  captcha: Scalars['String']['input'];
  garanzieSelezionate: Array<InputMaybe<Scalars['String']['input']>>;
  idQuotazione: Scalars['String']['input'];
  importoLordoAnnuo: Scalars['Float']['input'];
  massimaleFurto: Scalars['Float']['input'];
  prestazioneHomebox?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};

export type SalvaTrasformaQuotazioneAutoFast = {
  __typename?: 'SalvaTrasformaQuotazioneAutoFast';
  message?: Maybe<Scalars['String']['output']>;
  quotazione?: Maybe<QuotazioneFastQuoteAutoNode>;
  status?: Maybe<Scalars['Boolean']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  statusSalva?: Maybe<Scalars['Boolean']['output']>;
};

export type SalvaTrasformaQuotazioneAutoFastInput = {
  captcha: Scalars['String']['input'];
  cf: Scalars['String']['input'];
  garanzieSelezionate: Array<InputMaybe<Scalars['String']['input']>>;
  idQuotazione: Scalars['String']['input'];
  importoLordoAnnuo: Scalars['Float']['input'];
  importoLordoAnnuoScontato: Scalars['Float']['input'];
  keyPremio: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
};

export type SalvaTrasformaQuotazioneCasaFast = {
  __typename?: 'SalvaTrasformaQuotazioneCasaFast';
  message?: Maybe<Scalars['String']['output']>;
  quotazione?: Maybe<QuotazioneFastQuoteCasaNode>;
  status?: Maybe<Scalars['Boolean']['output']>;
  statusSalva?: Maybe<Scalars['Boolean']['output']>;
};

export type SalvaTrasformaQuotazioneCasaFastInput = {
  animali?: InputMaybe<Array<InputMaybe<AnimaleSalvaQuotazioneCasaFastInput>>>;
  captcha: Scalars['String']['input'];
  cf: Scalars['String']['input'];
  garanzieSelezionate: Array<InputMaybe<Scalars['String']['input']>>;
  idQuotazione: Scalars['String']['input'];
  importoLordoAnnuo: Scalars['Float']['input'];
  massimaleFurto: Scalars['Float']['input'];
  prestazioneHomebox?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchConnection = {
  __typename?: 'SearchConnection';
  count?: Maybe<Scalars['Int']['output']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SearchEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Search` and its cursor. */
export type SearchEdge = {
  __typename?: 'SearchEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SearchType>;
};

export type SearchObject = ArticoloMagazineNode | CategoriaNode | FaqNode | FascicoloNode | PaginaNode | ProdottoNode;

export type SearchType = Node & {
  __typename?: 'SearchType';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modelName?: Maybe<Scalars['String']['output']>;
  object?: Maybe<SearchObject>;
  score?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SeoType = {
  __typename?: 'SeoType';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SocialNode = Node & {
  __typename?: 'SocialNode';
  created: Scalars['DateTime']['output'];
  extraData?: Maybe<Scalars['SocialCamelJSON']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified: Scalars['DateTime']['output'];
  provider: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  user: UtenteNode;
};

export type SocialNodeConnection = {
  __typename?: 'SocialNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SocialNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SocialNode` and its cursor. */
export type SocialNodeEdge = {
  __typename?: 'SocialNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<SocialNode>;
};

export type TagFascicoloNode = Node & {
  __typename?: 'TagFascicoloNode';
  alias: Scalars['String']['output'];
  fascicoli: FascicoloNodeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
};


export type TagFascicoloNodeFascicoliArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_Equals?: InputMaybe<Scalars['String']['input']>;
  categoria_Slug_In?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  titolo?: InputMaybe<Scalars['String']['input']>;
  titolo_Icontains?: InputMaybe<Scalars['String']['input']>;
};

export type TagFondoNode = Node & {
  __typename?: 'TagFondoNode';
  alias: Scalars['String']['output'];
  fondiCatalogo: FondoCatalogoNodeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
};


export type TagFondoNodeFondiCatalogoArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  titolo?: InputMaybe<Scalars['String']['input']>;
  titolo_Icontains?: InputMaybe<Scalars['String']['input']>;
};

export type TagProdottoNode = Node & {
  __typename?: 'TagProdottoNode';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  prodotti: ProdottoNodeConnection;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
};


export type TagProdottoNodeProdottiArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TipologiaCampoCasaNode = Node & {
  __typename?: 'TipologiaCampoCasaNode';
  attivo: Scalars['Boolean']['output'];
  campo: FastquoteTipologiaCampoCasaCampoChoices;
  created?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  nome: Scalars['String']['output'];
  ordine: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
};

export type TipologiaContattoNode = Node & {
  __typename?: 'TipologiaContattoNode';
  alias: Scalars['String']['output'];
  attivo: Scalars['Boolean']['output'];
  campiFacoltativi?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  campiObbligatori?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created?: Maybe<Scalars['DateTime']['output']>;
  emailDestinatario: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  ordine: Scalars['Int']['output'];
  pk?: Maybe<Scalars['Int']['output']>;
  titolo: Scalars['String']['output'];
  titoloIt?: Maybe<Scalars['String']['output']>;
};

export type TrasformaQuotazioneCasaFast = {
  __typename?: 'TrasformaQuotazioneCasaFast';
  message?: Maybe<Scalars['String']['output']>;
  quotazione?: Maybe<QuotazioneFastQuoteCasaNode>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type TrasformaQuotazioneCasaFastInput = {
  captcha: Scalars['String']['input'];
  cf: Scalars['String']['input'];
  idQuotazione: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
};

export type UtenteNode = Node & {
  __typename?: 'UtenteNode';
  cognome?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  dataNascita?: Maybe<Scalars['Date']['output']>;
  dataRegistrazione?: Maybe<Scalars['String']['output']>;
  dateJoined: Scalars['DateTime']['output'];
  edit?: Maybe<Scalars['Boolean']['output']>;
  email: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Indica se l'utente si può loggare o meno */
  isActive: Scalars['Boolean']['output'];
  isImpersonate?: Maybe<Scalars['Boolean']['output']>;
  isStaff: Scalars['Boolean']['output'];
  /** Attribuisce all'utente tutti i privilegi, senza che sia necessario assegnarli esplicitamente. */
  isSuperuser: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  modified?: Maybe<Scalars['DateTime']['output']>;
  nome?: Maybe<Scalars['String']['output']>;
  pk?: Maybe<Scalars['Int']['output']>;
  privacy: Scalars['Boolean']['output'];
  privacyCommerciale: Scalars['Boolean']['output'];
  privacyProfilazione: Scalars['Boolean']['output'];
  sesso?: Maybe<Scalars['String']['output']>;
  socialAuth: SocialNodeConnection;
  /** Registrazione tramite social completata */
  socialCompleted: Scalars['Boolean']['output'];
  stopImpersonateUrl?: Maybe<Scalars['String']['output']>;
  telefono?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};


export type UtenteNodeSocialAuthArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Scalars['String']['input']>;
  uid_In?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ValoreQuotaNode = Node & {
  __typename?: 'ValoreQuotaNode';
  created?: Maybe<Scalars['DateTime']['output']>;
  data: Scalars['Date']['output'];
  /** currency */
  divisa: Scalars['String']['output'];
  fondo: FondoNode;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  pubblicato: Scalars['Boolean']['output'];
  valore: Scalars['Float']['output'];
  verificato: Scalars['Boolean']['output'];
};

export type ValoreQuotaNodeConnection = {
  __typename?: 'ValoreQuotaNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ValoreQuotaNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ValoreQuotaNode` and its cursor. */
export type ValoreQuotaNodeEdge = {
  __typename?: 'ValoreQuotaNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ValoreQuotaNode>;
};

export type VideoMagazineNode = Node & {
  __typename?: 'VideoMagazineNode';
  articolo: ArticoloMagazineNode;
  created?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  modified?: Maybe<Scalars['DateTime']['output']>;
  order: Scalars['Int']['output'];
  tipoVideo: MagazineVideoItemTipoVideoChoices;
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoMagazineNodeConnection = {
  __typename?: 'VideoMagazineNodeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<VideoMagazineNodeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `VideoMagazineNode` and its cursor. */
export type VideoMagazineNodeEdge = {
  __typename?: 'VideoMagazineNodeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<VideoMagazineNode>;
};

export type CatalogoFondiQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  titolo_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type CatalogoFondiQuery = { __typename?: 'Query', catalogoFondi?: { __typename?: 'FondoCatalogoNodeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'FondoCatalogoNodeEdge', node?: { __typename?: 'FondoCatalogoNode', pk?: number | null, titolo: string, descrizione?: string | null, edizione?: any | null, tags?: Array<{ __typename?: 'TagFondoNode', pk?: number | null, titolo: string } | null> | null, files?: Array<{ __typename?: 'FondoFileNode', pk?: number | null, titolo: string, url?: string | null } | null> | null } | null } | null> } | null };

export type CategorieQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieQuery = { __typename?: 'Query', categorie?: { __typename?: 'CategoriaNodeConnection', edges: Array<{ __typename?: 'CategoriaNodeEdge', node?: { __typename?: 'CategoriaNode', slugTree?: string | null } | null } | null> } | null };

export type CategoriaQueryVariables = Exact<{
  slugTree: Scalars['String']['input'];
  preview: Scalars['Boolean']['input'];
}>;


export type CategoriaQuery = { __typename?: 'Query', categoria?: { __typename?: 'CategoriaNode', pk?: number | null, slug: string, slugTree?: string | null, nome: string, titolo: string, descrizione?: string | null, descrizioneAggiuntiva?: string | null, statoPubblicazione: CategorieCategoriaStatoPubblicazioneChoices, mainImage?: string | null, previewImage?: string | null, adminUrl?: string | null, modelClass?: string | null, pubblicato?: boolean | null, visibile?: boolean | null, box?: { __typename?: 'BoxCategoriaNode', pk?: number | null, alias: string, key?: string | null, name: string, description?: string | null, blank: boolean, ctaLabel?: string | null, url?: string | null } | null, prodotti?: Array<{ __typename?: 'ProdottoNode', pk?: number | null, titolo: string, descrizioneBreve?: string | null, mainImage?: string | null, previewImage?: string | null, url?: string | null, tags?: Array<{ __typename?: 'TagProdottoNode', pk?: number | null, titolo: string } | null> | null } | null> | null, pagina?: { __typename?: 'PaginaNode', titolo: string, descrizione?: string | null, chiave?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', titolo?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null } | null } | null } | null };

export type TipologieContattoQueryVariables = Exact<{ [key: string]: never; }>;


export type TipologieContattoQuery = { __typename?: 'Query', tipologieContatto?: Array<{ __typename?: 'TipologiaContattoNode', pk?: number | null, alias: string, titolo: string, key: string, campiObbligatori?: Array<string | null> | null, campiFacoltativi?: Array<string | null> | null } | null> | null };

export type CreateRichiestaContattoMutationVariables = Exact<{
  input: RichiestaContattoInput;
}>;


export type CreateRichiestaContattoMutation = { __typename?: 'Mutation', createRichiestaContatto?: { __typename?: 'CreateRichiestaContatto', status?: boolean | null } | null };

export type CategorieFaqQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieFaqQuery = { __typename?: 'Query', categorieFaq?: { __typename?: 'CategoriaFaqNodeConnection', edges: Array<{ __typename?: 'CategoriaFaqNodeEdge', node?: { __typename?: 'CategoriaFaqNode', pk?: number | null, titolo?: string | null, descrizione?: string | null, slug: string, url?: string | null, style?: string | null } | null } | null> } | null };

export type CategoriaFaqQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type CategoriaFaqQuery = { __typename?: 'Query', categoriaFaq?: { __typename?: 'CategoriaFaqNode', titolo?: string | null, descrizione?: string | null, url?: string | null, faq?: Array<{ __typename?: 'FaqNode', pk?: number | null, slug: string, domanda: string, risposta?: string | null } | null> | null } | null };

export type FascicoliQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  categoria_Slug_In?: InputMaybe<Scalars['String']['input']>;
  titolo_Icontains?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type FascicoliQuery = { __typename?: 'Query', fascicoli?: { __typename?: 'FascicoloNodeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'FascicoloNodeEdge', node?: { __typename?: 'FascicoloNode', pk?: number | null, titolo: string, descrizione?: string | null, edizione?: any | null, categoria?: { __typename?: 'CategoriaFascicoloNode', pk?: number | null, nome: string } | null, tags?: Array<{ __typename?: 'TagFascicoloNode', pk?: number | null, titolo: string } | null> | null, files?: Array<{ __typename?: 'FascicoloFileNode', pk?: number | null, titolo: string, url?: string | null } | null> | null } | null } | null> } | null };

export type CategorieFascicoliQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieFascicoliQuery = { __typename?: 'Query', categorieFascicoli?: { __typename?: 'CategoriaFascicoloNodeConnection', edges: Array<{ __typename?: 'CategoriaFascicoloNodeEdge', node?: { __typename?: 'CategoriaFascicoloNode', pk?: number | null, nome: string, slug: string, numFascicoli?: number | null } | null } | null> } | null };

export type TipologieProprietaQueryVariables = Exact<{ [key: string]: never; }>;


export type TipologieProprietaQuery = { __typename?: 'Query', tipologieProprieta?: Array<{ __typename?: 'TipologiaCampoCasaNode', nome: string, titolo: string } | null> | null };

export type TipologieResidenzaQueryVariables = Exact<{ [key: string]: never; }>;


export type TipologieResidenzaQuery = { __typename?: 'Query', tipologieResidenza?: Array<{ __typename?: 'TipologiaCampoCasaNode', nome: string, titolo: string } | null> | null };

export type TipologieAbitazioneQueryVariables = Exact<{ [key: string]: never; }>;


export type TipologieAbitazioneQuery = { __typename?: 'Query', tipologieAbitazione?: Array<{ __typename?: 'TipologiaCampoCasaNode', nome: string, titolo: string } | null> | null };

export type QuotazioneFastQuoteCasaQueryVariables = Exact<{
  idQuotazione: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
  hashKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type QuotazioneFastQuoteCasaQuery = { __typename?: 'Query', quotazioneCasa?: { __typename?: 'QuotazioneFastQuoteCasaNode', pk?: number | null, idQuotazione?: string | null, ndg?: string | null, codContratto?: string | null, dataDecorrenza?: any | null, nome?: string | null, cognome?: string | null, email: string, completata?: boolean | null, isCliente?: boolean | null, errore: boolean, cf?: string | null, telefono?: string | null, etaMassimaCane?: number | null, etaMinimaCane?: number | null, etaMinimaGatto?: number | null, etaMassimaGatto?: number | null, proprieta?: string | null, cap?: string | null, tipoResidenza?: string | null, tipoAbitazione?: string | null, piano?: string | null, metriQuadrati?: number | null, valArredamento?: string | null, altraCopMutuo?: string | null, consensoTrattamento?: string | null, animali?: Array<{ __typename?: 'AnimaleFastQuoteCasaNode', pk?: number | null, nome?: string | null, dataNascita?: string | null, tipo?: string | null } | null> | null, garanzie?: Array<{ __typename?: 'GaranziaFastQuoteCasaNode', pk?: number | null, codice?: string | null, titolo?: string | null, descrizione?: string | null, descrizioneAggiuntiva?: string | null, icon?: string | null, file?: string | null, franchigiaDesc?: string | null, franchigia?: string | null, premioLordoAnnuo?: number | null, premioLordoMensile?: number | null, tipo?: string | null, massimale?: number | null, massimaleDesc?: string | null, keyMassimale?: number | null, children?: Array<{ __typename?: 'GaranziaFastQuoteCasaNode', pk?: number | null, codice?: string | null, titolo?: string | null, descrizione?: string | null, descrizioneAggiuntiva?: string | null, icon?: string | null, file?: string | null, franchigiaDesc?: string | null, franchigia?: string | null, premioLordoAnnuo?: number | null, premioLordoMensile?: number | null, tipo?: string | null, massimale?: number | null, massimaleDesc?: string | null, keyMassimale?: number | null } | null> | null } | null> | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, contentTypeId?: number | null, slug: string, titolo: string } | null } | null };

export type GetPremioCasaFastMutationVariables = Exact<{
  input: GetPremioCasaFastInput;
}>;


export type GetPremioCasaFastMutation = { __typename?: 'Mutation', getPremioCasaFast?: { __typename?: 'GetPremioCasaFast', status?: boolean | null, message?: string | null, quotazione?: { __typename?: 'QuotazioneFastQuoteCasaNode', idQuotazione?: string | null } | null } | null };

export type GetPremioCasaFastFullDetailMutationVariables = Exact<{
  input: GetPremioCasaFastInput;
}>;


export type GetPremioCasaFastFullDetailMutation = { __typename?: 'Mutation', getPremioCasaFast?: { __typename?: 'GetPremioCasaFast', status?: boolean | null, message?: string | null, quotazione?: { __typename?: 'QuotazioneFastQuoteCasaNode', pk?: number | null, idQuotazione?: string | null, ndg?: string | null, codContratto?: string | null, dataDecorrenza?: any | null, nome?: string | null, cognome?: string | null, email: string, completata?: boolean | null, isCliente?: boolean | null, errore: boolean, cf?: string | null, telefono?: string | null, etaMassimaCane?: number | null, etaMinimaCane?: number | null, etaMinimaGatto?: number | null, etaMassimaGatto?: number | null, proprieta?: string | null, cap?: string | null, tipoResidenza?: string | null, tipoAbitazione?: string | null, piano?: string | null, metriQuadrati?: number | null, valArredamento?: string | null, altraCopMutuo?: string | null, consensoTrattamento?: string | null, animali?: Array<{ __typename?: 'AnimaleFastQuoteCasaNode', pk?: number | null, nome?: string | null, dataNascita?: string | null, tipo?: string | null } | null> | null, garanzie?: Array<{ __typename?: 'GaranziaFastQuoteCasaNode', pk?: number | null, codice?: string | null, titolo?: string | null, descrizione?: string | null, descrizioneAggiuntiva?: string | null, icon?: string | null, file?: string | null, franchigiaDesc?: string | null, franchigia?: string | null, premioLordoAnnuo?: number | null, premioLordoMensile?: number | null, tipo?: string | null, massimale?: number | null, massimaleDesc?: string | null, keyMassimale?: number | null, children?: Array<{ __typename?: 'GaranziaFastQuoteCasaNode', pk?: number | null, codice?: string | null, titolo?: string | null, descrizione?: string | null, descrizioneAggiuntiva?: string | null, icon?: string | null, file?: string | null, franchigiaDesc?: string | null, franchigia?: string | null, premioLordoAnnuo?: number | null, premioLordoMensile?: number | null, tipo?: string | null, massimale?: number | null, massimaleDesc?: string | null, keyMassimale?: number | null } | null> | null } | null> | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, contentTypeId?: number | null, slug: string, titolo: string } | null } | null } | null };

export type SalvaTrasformaQuotazioneFastQuoteCasaMutationVariables = Exact<{
  input: SalvaTrasformaQuotazioneCasaFastInput;
}>;


export type SalvaTrasformaQuotazioneFastQuoteCasaMutation = { __typename?: 'Mutation', salvaTrasformaQuotazioneCasaFast?: { __typename?: 'SalvaTrasformaQuotazioneCasaFast', status?: boolean | null, statusSalva?: boolean | null, message?: string | null, quotazione?: { __typename?: 'QuotazioneFastQuoteCasaNode', idQuotazione?: string | null, ndg?: string | null, codContratto?: string | null, isCliente?: boolean | null } | null } | null };

export type QuotazioneThankYouFastQuoteCasaQueryVariables = Exact<{
  idQuotazione: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
  resetSession: Scalars['Boolean']['input'];
}>;


export type QuotazioneThankYouFastQuoteCasaQuery = { __typename?: 'Query', quotazioneCasa?: { __typename?: 'QuotazioneFastQuoteCasaNode', pk?: number | null, idQuotazione?: string | null, nome?: string | null, cognome?: string | null, email: string, importoLordoAnnuo?: number | null, garanzieSelezionate?: Array<{ __typename?: 'GaranziaFastQuoteCasaNode', pk?: number | null, codice?: string | null, titolo?: string | null, importoLordoAnnuo?: number | null, tipo?: string | null } | null> | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, contentTypeId?: number | null, slug: string, titolo: string, prodottiCorrelati: { __typename?: 'ProdottoNodeConnection', edges: Array<{ __typename?: 'ProdottoNodeEdge', node?: { __typename?: 'ProdottoNode', pk?: number | null, titolo: string, descrizioneBreve?: string | null, mainImage?: string | null, previewImage?: string | null, url?: string | null, tags?: Array<{ __typename?: 'TagProdottoNode', pk?: number | null, titolo: string } | null> | null } | null } | null> } } | null } | null };

export type QuotazioneFastQuoteAutoQueryVariables = Exact<{
  idQuotazione: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
  hashKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type QuotazioneFastQuoteAutoQuery = { __typename?: 'Query', quotazioneAuto?: { __typename?: 'QuotazioneFastQuoteAutoNode', pk?: number | null, idQuotazione?: string | null, ndg?: string | null, codContratto?: string | null, dataDecorrenza?: any | null, nome?: string | null, cognome?: string | null, email: string, completata?: boolean | null, isCliente?: boolean | null, errore: boolean, cf?: string | null, telefono?: string | null, targa: string, dataNascita: any, cap?: string | null, marcaAuto?: string | null, modelloAuto?: string | null, listaCap?: string | null, sistemaAdas?: string | null, antifurto?: string | null, tipoGuida?: string | null, massimaleRca?: string | null, massimaleCristalli?: string | null, scontoPacchettoPersona?: number | null, scontoPacchettoVeicolo?: number | null, scontoPacchettoEventi?: number | null, scontoPacchettoPersonaVeicolo?: number | null, scontoPacchettoVeicoloEventi?: number | null, scontoPacchettoPersonaEventi?: number | null, scontoPacchettoPersonaVeicoloEventi?: number | null, consensoTrattamento?: string | null, allestimentoCodice?: string | null, allestimentoDescrizione?: string | null, allestimentiAuto?: Array<{ __typename?: 'AllestimentoAutoNode', codice: string, descrizione?: string | null, selezionato: boolean } | null> | null, pacchetti?: Array<{ __typename?: 'PacchettoGaranziaFastQuoteAutoNode', codice: string, titolo?: string | null, descrizione?: string | null } | null> | null, campiSistemaAdas?: Array<{ __typename?: 'CampoQuotazioneFastQuoteAutoNode', nome?: string | null, value?: string | null } | null> | null, campiAntifurto?: Array<{ __typename?: 'CampoQuotazioneFastQuoteAutoNode', nome?: string | null, value?: string | null } | null> | null, campiTipoGuida?: Array<{ __typename?: 'CampoQuotazioneFastQuoteAutoNode', nome?: string | null, value?: string | null } | null> | null, garanzie?: Array<{ __typename?: 'GaranziaFastQuoteAutoNode', pk?: number | null, codice?: string | null, titolo?: string | null, descrizione?: string | null, descrizioneAggiuntiva?: string | null, icon?: string | null, file?: string | null, franchigiaDesc?: string | null, franchigia?: string | null, importoLordoAnnuo?: number | null, importoLordoAnnuoScontato?: number | null, statoIniziale?: string | null, massimale?: number | null, keyPremio?: string | null, garanzieAbbinate?: Array<string | null> | null, garanzieNecessariePacchettoVeicolo?: Array<string | null> | null, garanzieNecessariePacchettoPersona?: Array<string | null> | null, garanzieNecessariePacchettoEventi?: Array<string | null> | null, garanzieEscluse?: Array<string | null> | null, pacchetto?: { __typename?: 'PacchettoGaranziaFastQuoteAutoNode', codice: string, titolo?: string | null, descrizione?: string | null } | null, children?: Array<{ __typename?: 'GaranziaFastQuoteAutoNode', pk?: number | null, codice?: string | null, titolo?: string | null, descrizione?: string | null, descrizioneAggiuntiva?: string | null, icon?: string | null, file?: string | null, franchigiaDesc?: string | null, franchigia?: string | null, importoLordoAnnuo?: number | null, importoLordoAnnuoScontato?: number | null, statoIniziale?: string | null, massimale?: number | null, keyPremio?: string | null, garanzieAbbinate?: Array<string | null> | null, garanzieNecessariePacchettoVeicolo?: Array<string | null> | null, garanzieNecessariePacchettoPersona?: Array<string | null> | null, garanzieNecessariePacchettoEventi?: Array<string | null> | null, garanzieEscluse?: Array<string | null> | null, pacchetto?: { __typename?: 'PacchettoGaranziaFastQuoteAutoNode', codice: string, titolo?: string | null, descrizione?: string | null } | null } | null> | null } | null> | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, contentTypeId?: number | null, slug: string, titolo: string } | null } | null };

export type QuotazioneThankYouFastQuoteAutoQueryVariables = Exact<{
  idQuotazione: Scalars['String']['input'];
  siteId?: InputMaybe<Scalars['Int']['input']>;
  resetSession: Scalars['Boolean']['input'];
}>;


export type QuotazioneThankYouFastQuoteAutoQuery = { __typename?: 'Query', quotazioneAuto?: { __typename?: 'QuotazioneFastQuoteAutoNode', pk?: number | null, idQuotazione?: string | null, nome?: string | null, cognome?: string | null, email: string, importoLordoAnnuo?: number | null, importoLordoAnnuoScontato?: number | null, garanzieSelezionate?: Array<{ __typename?: 'GaranziaFastQuoteAutoNode', pk?: number | null, codice?: string | null, titolo?: string | null, importoLordoAnnuo?: number | null, importoLordoAnnuoScontato?: number | null, statoIniziale?: string | null, pacchetto?: { __typename?: 'PacchettoGaranziaFastQuoteAutoNode', titolo?: string | null } | null } | null> | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, contentTypeId?: number | null, slug: string, titolo: string, prodottiCorrelati: { __typename?: 'ProdottoNodeConnection', edges: Array<{ __typename?: 'ProdottoNodeEdge', node?: { __typename?: 'ProdottoNode', pk?: number | null, titolo: string, descrizioneBreve?: string | null, mainImage?: string | null, previewImage?: string | null, url?: string | null, tags?: Array<{ __typename?: 'TagProdottoNode', pk?: number | null, titolo: string } | null> | null } | null } | null> } } | null } | null };

export type GetPremioAutoFastMutationVariables = Exact<{
  input: GetPremioAutoFastInput;
}>;


export type GetPremioAutoFastMutation = { __typename?: 'Mutation', getPremioAutoFast?: { __typename?: 'GetPremioAutoFast', status?: boolean | null, message?: string | null, inputError?: string | null, quotazione?: { __typename?: 'QuotazioneFastQuoteAutoNode', idQuotazione?: string | null } | null } | null };

export type GetPremioAutoFastFullDetailMutationVariables = Exact<{
  input: GetPremioAutoFastInput;
}>;


export type GetPremioAutoFastFullDetailMutation = { __typename?: 'Mutation', getPremioAutoFast?: { __typename?: 'GetPremioAutoFast', status?: boolean | null, message?: string | null, inputError?: string | null, quotazione?: { __typename?: 'QuotazioneFastQuoteAutoNode', pk?: number | null, idQuotazione?: string | null, ndg?: string | null, codContratto?: string | null, dataDecorrenza?: any | null, nome?: string | null, cognome?: string | null, email: string, completata?: boolean | null, isCliente?: boolean | null, errore: boolean, cf?: string | null, telefono?: string | null, targa: string, dataNascita: any, cap?: string | null, marcaAuto?: string | null, modelloAuto?: string | null, listaCap?: string | null, sistemaAdas?: string | null, antifurto?: string | null, tipoGuida?: string | null, massimaleRca?: string | null, massimaleCristalli?: string | null, scontoPacchettoPersona?: number | null, scontoPacchettoVeicolo?: number | null, scontoPacchettoEventi?: number | null, scontoPacchettoPersonaVeicolo?: number | null, scontoPacchettoVeicoloEventi?: number | null, scontoPacchettoPersonaEventi?: number | null, scontoPacchettoPersonaVeicoloEventi?: number | null, consensoTrattamento?: string | null, allestimentoCodice?: string | null, allestimentoDescrizione?: string | null, allestimentiAuto?: Array<{ __typename?: 'AllestimentoAutoNode', codice: string, descrizione?: string | null, selezionato: boolean } | null> | null, pacchetti?: Array<{ __typename?: 'PacchettoGaranziaFastQuoteAutoNode', codice: string, titolo?: string | null, descrizione?: string | null } | null> | null, campiSistemaAdas?: Array<{ __typename?: 'CampoQuotazioneFastQuoteAutoNode', nome?: string | null, value?: string | null } | null> | null, campiAntifurto?: Array<{ __typename?: 'CampoQuotazioneFastQuoteAutoNode', nome?: string | null, value?: string | null } | null> | null, campiTipoGuida?: Array<{ __typename?: 'CampoQuotazioneFastQuoteAutoNode', nome?: string | null, value?: string | null } | null> | null, garanzie?: Array<{ __typename?: 'GaranziaFastQuoteAutoNode', pk?: number | null, codice?: string | null, titolo?: string | null, descrizione?: string | null, descrizioneAggiuntiva?: string | null, icon?: string | null, file?: string | null, franchigiaDesc?: string | null, franchigia?: string | null, importoLordoAnnuo?: number | null, importoLordoAnnuoScontato?: number | null, statoIniziale?: string | null, massimale?: number | null, keyPremio?: string | null, garanzieAbbinate?: Array<string | null> | null, garanzieNecessariePacchettoVeicolo?: Array<string | null> | null, garanzieNecessariePacchettoPersona?: Array<string | null> | null, garanzieNecessariePacchettoEventi?: Array<string | null> | null, garanzieEscluse?: Array<string | null> | null, pacchetto?: { __typename?: 'PacchettoGaranziaFastQuoteAutoNode', codice: string, titolo?: string | null, descrizione?: string | null } | null, children?: Array<{ __typename?: 'GaranziaFastQuoteAutoNode', pk?: number | null, codice?: string | null, titolo?: string | null, descrizione?: string | null, descrizioneAggiuntiva?: string | null, icon?: string | null, file?: string | null, franchigiaDesc?: string | null, franchigia?: string | null, importoLordoAnnuo?: number | null, importoLordoAnnuoScontato?: number | null, statoIniziale?: string | null, massimale?: number | null, keyPremio?: string | null, garanzieAbbinate?: Array<string | null> | null, garanzieNecessariePacchettoVeicolo?: Array<string | null> | null, garanzieNecessariePacchettoPersona?: Array<string | null> | null, garanzieNecessariePacchettoEventi?: Array<string | null> | null, garanzieEscluse?: Array<string | null> | null, pacchetto?: { __typename?: 'PacchettoGaranziaFastQuoteAutoNode', codice: string, titolo?: string | null, descrizione?: string | null } | null } | null> | null } | null> | null, prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, contentTypeId?: number | null, slug: string, titolo: string } | null } | null } | null };

export type SalvaTrasformaQuotazioneFastQuoteAutoMutationVariables = Exact<{
  input: SalvaTrasformaQuotazioneAutoFastInput;
}>;


export type SalvaTrasformaQuotazioneFastQuoteAutoMutation = { __typename?: 'Mutation', salvaTrasformaQuotazioneAutoFast?: { __typename?: 'SalvaTrasformaQuotazioneAutoFast', status?: boolean | null, statusSalva?: boolean | null, message?: string | null, statusCode?: number | null, quotazione?: { __typename?: 'QuotazioneFastQuoteAutoNode', idQuotazione?: string | null, ndg?: string | null, codContratto?: string | null, isCliente?: boolean | null } | null } | null };

export type CategorieFondoQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieFondoQuery = { __typename?: 'Query', categorieFondo?: { __typename?: 'CategoriaFondoNodeConnection', edges: Array<{ __typename?: 'CategoriaFondoNodeEdge', node?: { __typename?: 'CategoriaFondoNode', pk?: number | null, nome: string, slug: string } | null } | null> } | null };

export type FondiQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  descrizioneCompleta_Icontains?: InputMaybe<Scalars['String']['input']>;
  categorie_Slug_Equals?: InputMaybe<Scalars['String']['input']>;
  tipologia?: InputMaybe<Scalars['String']['input']>;
}>;


export type FondiQuery = { __typename?: 'Query', fondi?: { __typename?: 'FondoNodeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'FondoNodeEdge', node?: { __typename?: 'FondoNode', pk?: number | null, codiceFondo: string, descrizioneCompleta: string, codiceIsin?: string | null, tipologia?: string | null, prospettoUrl?: string | null, prospettoFile?: string | null, valoreQuota?: { __typename?: 'ValoreQuotaNode', valore: number, data: any, divisa: string } | null } | null } | null> } | null };

export type PaginaQueryVariables = Exact<{
  chiave?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  contentTypeId?: InputMaybe<Scalars['Int']['input']>;
  objectId?: InputMaybe<Scalars['Int']['input']>;
  preview?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PaginaQuery = { __typename?: 'Query', pagina?: { __typename?: 'PaginaNode', pk?: number | null, nome?: string | null, titolo: string, descrizione?: string | null, chiave?: string | null, contentTypeId?: string | null, mainImage?: string | null, previewImage?: string | null, visibile?: boolean | null, pubblicato?: boolean | null, visibilitaDal?: string | null, visibilitaAl?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', titolo?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null } | null } | null };

export type PagineQueryVariables = Exact<{ [key: string]: never; }>;


export type PagineQuery = { __typename?: 'Query', pagine?: { __typename?: 'PaginaNodeConnection', edges: Array<{ __typename?: 'PaginaNodeEdge', node?: { __typename?: 'PaginaNode', path?: string | null, tipologia: PagesPaginaTipologiaChoices } | null } | null> } | null };

export type ArticoloMagazineQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  preview: Scalars['Boolean']['input'];
}>;


export type ArticoloMagazineQuery = { __typename?: 'Query', articoloMagazine?: { __typename?: 'ArticoloMagazineNode', contentTypeId?: number | null, adminUrl?: string | null, modelClass?: string | null, pk?: number | null, title?: string | null, mainImage?: string | null, mainImageThumb?: string | null, publicationDate?: string | null, visibile?: boolean | null, categoria?: { __typename?: 'CategoriaArticoloNode', title?: string | null } | null, immagini?: Array<{ __typename?: 'ImmagineMagazineNode', file?: string | null } | null> | null, prev?: { __typename?: 'ArticoloMagazineNode', url?: string | null } | null, next?: { __typename?: 'ArticoloMagazineNode', url?: string | null } | null, correlati?: Array<{ __typename?: 'ArticoloMagazineNode', pk?: number | null, title?: string | null, publicationDate?: string | null, abstract?: string | null, thumbnailSmall?: string | null, url?: string | null, categoria?: { __typename?: 'CategoriaArticoloNode', title?: string | null } | null } | null> | null, pagina?: { __typename?: 'PaginaNode', adminUrl?: string | null, chiave?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', titolo?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null } | null } | null } | null };

export type CategorieArticoliQueryVariables = Exact<{ [key: string]: never; }>;


export type CategorieArticoliQuery = { __typename?: 'Query', categorieArticoli?: { __typename?: 'CategoriaArticoloNodeConnection', edges: Array<{ __typename?: 'CategoriaArticoloNodeEdge', node?: { __typename?: 'CategoriaArticoloNode', pk?: number | null, title?: string | null, slug?: string | null, numArticoli?: number | null } | null } | null> } | null };

export type ArticoliMagazineQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  categoria_Slug_In?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ArticoliMagazineQuery = { __typename?: 'Query', articoliMagazine?: { __typename?: 'ArticoloMagazineNodeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'ArticoloMagazineNodeEdge', node?: { __typename?: 'ArticoloMagazineNode', slug: string, pk?: number | null, title?: string | null, abstract?: string | null, mainImage?: string | null, url?: string | null, publicationDate?: string | null, categoria?: { __typename?: 'CategoriaArticoloNode', title?: string | null } | null } | null } | null> } | null };

export type MagazineQueryVariables = Exact<{ [key: string]: never; }>;


export type MagazineQuery = { __typename?: 'Query', articoliMagazine?: { __typename?: 'ArticoloMagazineNodeConnection', edges: Array<{ __typename?: 'ArticoloMagazineNodeEdge', node?: { __typename?: 'ArticoloMagazineNode', pk?: number | null, title?: string | null, publicationDate?: string | null, abstract?: string | null, thumbnailBig?: string | null, thumbnailSmall?: string | null, url?: string | null, categoria?: { __typename?: 'CategoriaArticoloNode', title?: string | null } | null } | null } | null> } | null, categorieArticoli?: { __typename?: 'CategoriaArticoloNodeConnection', edges: Array<{ __typename?: 'CategoriaArticoloNodeEdge', node?: { __typename?: 'CategoriaArticoloNode', title?: string | null, slug?: string | null } | null } | null> } | null };

export type MenuQueryVariables = Exact<{ [key: string]: never; }>;


export type MenuQuery = { __typename?: 'Query', menuitems?: { __typename?: 'MenuItemNodeConnection', edges: Array<{ __typename?: 'MenuItemNodeEdge', node?: { __typename?: 'MenuItemNode', id: string, pk?: number | null, alias?: string | null, key?: string | null, attivo?: boolean | null, name?: string | null, mainImage?: string | null, mainImageResponsive?: string | null, url?: string | null, children?: { __typename?: 'MenuItemNodeConnection', edges: Array<{ __typename?: 'MenuItemNodeEdge', node?: { __typename?: 'MenuItemNode', id: string, pk?: number | null, alias?: string | null, key?: string | null, attivo?: boolean | null, name?: string | null, mainImage?: string | null, mainImageResponsive?: string | null, url?: string | null, children?: { __typename?: 'MenuItemNodeConnection', edges: Array<{ __typename?: 'MenuItemNodeEdge', node?: { __typename?: 'MenuItemNode', id: string, pk?: number | null, alias?: string | null, key?: string | null, attivo?: boolean | null, name?: string | null, mainImage?: string | null, mainImageResponsive?: string | null, url?: string | null } | null } | null> } | null } | null } | null> } | null } | null } | null> } | null };

export type CreateRichiestaPreventivatoreMutationVariables = Exact<{
  input: RichiestaPreventivatoreInput;
}>;


export type CreateRichiestaPreventivatoreMutation = { __typename?: 'Mutation', createRichiestaPreventivatore?: { __typename?: 'CreateRichiestaPreventivatore', status?: boolean | null } | null };

export type ProdottoQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  preview: Scalars['Boolean']['input'];
}>;


export type ProdottoQuery = { __typename?: 'Query', prodotto?: { __typename?: 'ProdottoNode', pk?: number | null, contentTypeId?: number | null, url?: string | null, slug: string, titolo: string, descrizione?: string | null, descrizioneBreve?: string | null, mainImage?: string | null, previewImage?: string | null, adminUrl?: string | null, modelClass?: string | null, preventivatore: boolean, icon?: string | null, sconto?: string | null, pubblicato?: boolean | null, visibile?: boolean | null, tags?: Array<{ __typename?: 'TagProdottoNode', pk?: number | null, titolo: string } | null> | null, linee?: Array<{ __typename?: 'LineaNode', pk?: number | null, titolo: string, description?: string | null, style?: string | null, label?: string | null, inPreventivatore: boolean, icon?: string | null, descrizioneBreve?: string | null, prezzo?: number | null, garanzieIncluse?: Array<{ __typename?: 'GaranziaLineaNode', pk?: number | null, titolo: string, style?: string | null, info?: string | null } | null> | null, garanzieOpzionali?: Array<{ __typename?: 'GaranziaLineaNode', pk?: number | null, titolo: string, style?: string | null, info?: string | null } | null> | null } | null> | null, faqs?: Array<{ __typename?: 'FaqProdottoNode', pk?: number | null, domanda: string, risposta?: string | null } | null> | null, prodottiCorrelati: { __typename?: 'ProdottoNodeConnection', edges: Array<{ __typename?: 'ProdottoNodeEdge', node?: { __typename?: 'ProdottoNode', pk?: number | null, titolo: string, descrizioneBreve?: string | null, mainImage?: string | null, previewImage?: string | null, url?: string | null, tags?: Array<{ __typename?: 'TagProdottoNode', pk?: number | null, titolo: string } | null> | null } | null } | null> }, pagina?: { __typename?: 'PaginaNode', titolo: string, descrizione?: string | null, chiave?: string | null, breadcrumbs?: Array<{ __typename?: 'BreadcrumbType', titolo?: string | null, url?: string | null } | null> | null, seo?: { __typename?: 'SeoType', title?: string | null, description?: string | null, image?: string | null } | null } | null, menuItems?: { __typename?: 'ProdottoMenuItemNode', pk?: number | null, alias?: string | null, key?: string | null, attivo?: boolean | null, style?: string | null, name?: string | null, mainImage?: string | null, mainImageResponsive?: string | null, description?: string | null, ctaLabel?: string | null, blank?: boolean | null, url?: string | null, children: { __typename?: 'ProdottoMenuItemNodeConnection', edges: Array<{ __typename?: 'ProdottoMenuItemNodeEdge', node?: { __typename?: 'ProdottoMenuItemNode', pk?: number | null, alias?: string | null, key?: string | null, attivo?: boolean | null, style?: string | null, name?: string | null, mainImage?: string | null, mainImageResponsive?: string | null, description?: string | null, ctaLabel?: string | null, blank?: boolean | null, url?: string | null, children: { __typename?: 'ProdottoMenuItemNodeConnection', edges: Array<{ __typename?: 'ProdottoMenuItemNodeEdge', node?: { __typename?: 'ProdottoMenuItemNode', pk?: number | null, alias?: string | null, key?: string | null, attivo?: boolean | null, style?: string | null, name?: string | null, mainImage?: string | null, mainImageResponsive?: string | null, description?: string | null, ctaLabel?: string | null, blank?: boolean | null, url?: string | null, children: { __typename?: 'ProdottoMenuItemNodeConnection', edges: Array<{ __typename?: 'ProdottoMenuItemNodeEdge', node?: { __typename?: 'ProdottoMenuItemNode', pk?: number | null, alias?: string | null, key?: string | null, attivo?: boolean | null, style?: string | null, name?: string | null, mainImage?: string | null, mainImageResponsive?: string | null, description?: string | null, ctaLabel?: string | null, blank?: boolean | null, url?: string | null } | null } | null> } } | null } | null> } } | null } | null> } } | null } | null };

export type ProdottiQueryVariables = Exact<{ [key: string]: never; }>;


export type ProdottiQuery = { __typename?: 'Query', prodotti?: { __typename?: 'ProdottoNodeConnection', edges: Array<{ __typename?: 'ProdottoNodeEdge', node?: { __typename?: 'ProdottoNode', slug: string, categoria?: { __typename?: 'CategoriaNode', slugTree?: string | null } | null } | null } | null> } | null };

export type ProdottiPreventivatoreQueryVariables = Exact<{ [key: string]: never; }>;


export type ProdottiPreventivatoreQuery = { __typename?: 'Query', prodottiPreventivatore?: { __typename?: 'ProdottoNodeConnection', edges: Array<{ __typename?: 'ProdottoNodeEdge', node?: { __typename?: 'ProdottoNode', pk?: number | null, contentTypeId?: number | null, url?: string | null, slug: string, titolo: string, descrizione?: string | null, descrizioneBreve?: string | null, preventivatore: boolean, icon?: string | null, sconto?: string | null, linee?: Array<{ __typename?: 'LineaNode', pk?: number | null, titolo: string, description?: string | null, style?: string | null, label?: string | null, inPreventivatore: boolean, icon?: string | null, descrizioneBreve?: string | null, prezzo?: number | null, garanzieIncluse?: Array<{ __typename?: 'GaranziaLineaNode', pk?: number | null, titolo: string, style?: string | null, info?: string | null } | null> | null, garanzieOpzionali?: Array<{ __typename?: 'GaranziaLineaNode', pk?: number | null, titolo: string, style?: string | null, info?: string | null } | null> | null } | null> | null } | null } | null> } | null };

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  models?: InputMaybe<Array<InputMaybe<Modello>> | InputMaybe<Modello>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search?: { __typename?: 'SearchConnection', totalCount?: number | null, count?: number | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'SearchEdge', node?: { __typename?: 'SearchType', modelName?: string | null, score?: number | null, url?: string | null, object?: { __typename?: 'ArticoloMagazineNode', contentTypeId?: number | null, pk?: number | null, title?: string | null, abstract?: string | null, publicationDate?: string | null, mainImage?: string | null, thumbnailSmall?: string | null, url?: string | null, categoria?: { __typename?: 'CategoriaArticoloNode', title?: string | null } | null } | { __typename?: 'CategoriaNode', pk?: number | null, nome: string, titolo: string, descrizione?: string | null, mainImage?: string | null, previewImage?: string | null, url?: string | null } | { __typename?: 'FaqNode', pk?: number | null, domanda: string, risposta?: string | null, url?: string | null, categoriaFaq: { __typename?: 'CategoriaFaqNode', pk?: number | null, titolo?: string | null, slug: string, descrizione?: string | null } } | { __typename?: 'FascicoloNode', pk?: number | null, titolo: string, edizione?: any | null, descrizione?: string | null, url?: string | null } | { __typename?: 'PaginaNode', pk?: number | null, titolo: string, descrizione?: string | null, url?: string | null } | { __typename?: 'ProdottoNode', pk?: number | null, titolo: string, mainImage?: string | null, previewImage?: string | null, url?: string | null, descrizioneBreve?: string | null, tags?: Array<{ __typename?: 'TagProdottoNode', pk?: number | null, titolo: string } | null> | null } | null } | null } | null> } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UtenteNode', pk?: number | null, email: string, nome?: string | null, cognome?: string | null, completed?: boolean | null, isStaff: boolean, edit?: boolean | null, isImpersonate?: boolean | null, stopImpersonateUrl?: string | null } | null };

export type CalcolaCodiceFiscaleMutationVariables = Exact<{
  input: CalcolaCodiceFiscaleInput;
}>;


export type CalcolaCodiceFiscaleMutation = { __typename?: 'Mutation', calcolaCodiceFiscale?: { __typename?: 'CalcolaCodiceFiscale', status?: boolean | null, cf?: string | null } | null };


export const CatalogoFondiDocument = gql`
    query CatalogoFondi($offset: Int, $first: Int, $titolo_Icontains: String, $orderBy: String) {
  catalogoFondi(
    offset: $offset
    first: $first
    titolo_Icontains: $titolo_Icontains
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        pk
        titolo
        descrizione
        edizione
        tags {
          pk
          titolo
        }
        files {
          pk
          titolo
          url
        }
      }
    }
  }
}
    `;

/**
 * __useCatalogoFondiQuery__
 *
 * To run a query within a React component, call `useCatalogoFondiQuery` and pass it any options that fit your needs.
 * When your component renders, `useCatalogoFondiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCatalogoFondiQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *      titolo_Icontains: // value for 'titolo_Icontains'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCatalogoFondiQuery(baseOptions?: Apollo.QueryHookOptions<CatalogoFondiQuery, CatalogoFondiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CatalogoFondiQuery, CatalogoFondiQueryVariables>(CatalogoFondiDocument, options);
      }
export function useCatalogoFondiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CatalogoFondiQuery, CatalogoFondiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CatalogoFondiQuery, CatalogoFondiQueryVariables>(CatalogoFondiDocument, options);
        }
export type CatalogoFondiQueryHookResult = ReturnType<typeof useCatalogoFondiQuery>;
export type CatalogoFondiLazyQueryHookResult = ReturnType<typeof useCatalogoFondiLazyQuery>;
export type CatalogoFondiQueryResult = Apollo.QueryResult<CatalogoFondiQuery, CatalogoFondiQueryVariables>;
export const CategorieDocument = gql`
    query Categorie {
  categorie {
    edges {
      node {
        slugTree
      }
    }
  }
}
    `;

/**
 * __useCategorieQuery__
 *
 * To run a query within a React component, call `useCategorieQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieQuery(baseOptions?: Apollo.QueryHookOptions<CategorieQuery, CategorieQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieQuery, CategorieQueryVariables>(CategorieDocument, options);
      }
export function useCategorieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieQuery, CategorieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieQuery, CategorieQueryVariables>(CategorieDocument, options);
        }
export type CategorieQueryHookResult = ReturnType<typeof useCategorieQuery>;
export type CategorieLazyQueryHookResult = ReturnType<typeof useCategorieLazyQuery>;
export type CategorieQueryResult = Apollo.QueryResult<CategorieQuery, CategorieQueryVariables>;
export const CategoriaDocument = gql`
    query Categoria($slugTree: String!, $preview: Boolean!) {
  categoria(slugTree: $slugTree, preview: $preview) {
    pk
    slug
    slugTree
    nome
    titolo
    descrizione
    descrizioneAggiuntiva
    statoPubblicazione
    mainImage
    previewImage
    adminUrl
    modelClass
    box {
      pk
      alias
      key
      name
      description
      url: finalUrl
      blank
      ctaLabel
    }
    prodotti {
      pk
      titolo
      descrizioneBreve
      mainImage
      previewImage
      url
      tags {
        pk
        titolo
      }
    }
    pagina {
      titolo
      breadcrumbs {
        titolo
        url
      }
      seo {
        title
        description
        image
      }
      descrizione
      chiave
    }
    pubblicato
    visibile
  }
}
    `;

/**
 * __useCategoriaQuery__
 *
 * To run a query within a React component, call `useCategoriaQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriaQuery({
 *   variables: {
 *      slugTree: // value for 'slugTree'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useCategoriaQuery(baseOptions: Apollo.QueryHookOptions<CategoriaQuery, CategoriaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriaQuery, CategoriaQueryVariables>(CategoriaDocument, options);
      }
export function useCategoriaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriaQuery, CategoriaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriaQuery, CategoriaQueryVariables>(CategoriaDocument, options);
        }
export type CategoriaQueryHookResult = ReturnType<typeof useCategoriaQuery>;
export type CategoriaLazyQueryHookResult = ReturnType<typeof useCategoriaLazyQuery>;
export type CategoriaQueryResult = Apollo.QueryResult<CategoriaQuery, CategoriaQueryVariables>;
export const TipologieContattoDocument = gql`
    query tipologieContatto {
  tipologieContatto {
    pk
    alias
    titolo
    key
    campiObbligatori
    campiFacoltativi
  }
}
    `;

/**
 * __useTipologieContattoQuery__
 *
 * To run a query within a React component, call `useTipologieContattoQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipologieContattoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipologieContattoQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipologieContattoQuery(baseOptions?: Apollo.QueryHookOptions<TipologieContattoQuery, TipologieContattoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TipologieContattoQuery, TipologieContattoQueryVariables>(TipologieContattoDocument, options);
      }
export function useTipologieContattoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TipologieContattoQuery, TipologieContattoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TipologieContattoQuery, TipologieContattoQueryVariables>(TipologieContattoDocument, options);
        }
export type TipologieContattoQueryHookResult = ReturnType<typeof useTipologieContattoQuery>;
export type TipologieContattoLazyQueryHookResult = ReturnType<typeof useTipologieContattoLazyQuery>;
export type TipologieContattoQueryResult = Apollo.QueryResult<TipologieContattoQuery, TipologieContattoQueryVariables>;
export const CreateRichiestaContattoDocument = gql`
    mutation createRichiestaContatto($input: RichiestaContattoInput!) {
  createRichiestaContatto(input: $input) {
    status
  }
}
    `;
export type CreateRichiestaContattoMutationFn = Apollo.MutationFunction<CreateRichiestaContattoMutation, CreateRichiestaContattoMutationVariables>;

/**
 * __useCreateRichiestaContattoMutation__
 *
 * To run a mutation, you first call `useCreateRichiestaContattoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRichiestaContattoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRichiestaContattoMutation, { data, loading, error }] = useCreateRichiestaContattoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRichiestaContattoMutation(baseOptions?: Apollo.MutationHookOptions<CreateRichiestaContattoMutation, CreateRichiestaContattoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRichiestaContattoMutation, CreateRichiestaContattoMutationVariables>(CreateRichiestaContattoDocument, options);
      }
export type CreateRichiestaContattoMutationHookResult = ReturnType<typeof useCreateRichiestaContattoMutation>;
export type CreateRichiestaContattoMutationResult = Apollo.MutationResult<CreateRichiestaContattoMutation>;
export type CreateRichiestaContattoMutationOptions = Apollo.BaseMutationOptions<CreateRichiestaContattoMutation, CreateRichiestaContattoMutationVariables>;
export const CategorieFaqDocument = gql`
    query CategorieFaq {
  categorieFaq {
    edges {
      node {
        pk
        titolo
        descrizione
        slug
        url
        style
      }
    }
  }
}
    `;

/**
 * __useCategorieFaqQuery__
 *
 * To run a query within a React component, call `useCategorieFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieFaqQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieFaqQuery(baseOptions?: Apollo.QueryHookOptions<CategorieFaqQuery, CategorieFaqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieFaqQuery, CategorieFaqQueryVariables>(CategorieFaqDocument, options);
      }
export function useCategorieFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieFaqQuery, CategorieFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieFaqQuery, CategorieFaqQueryVariables>(CategorieFaqDocument, options);
        }
export type CategorieFaqQueryHookResult = ReturnType<typeof useCategorieFaqQuery>;
export type CategorieFaqLazyQueryHookResult = ReturnType<typeof useCategorieFaqLazyQuery>;
export type CategorieFaqQueryResult = Apollo.QueryResult<CategorieFaqQuery, CategorieFaqQueryVariables>;
export const CategoriaFaqDocument = gql`
    query categoriaFaq($slug: String!) {
  categoriaFaq(slug: $slug) {
    titolo
    descrizione
    url
    faq {
      pk
      slug
      domanda
      risposta
    }
  }
}
    `;

/**
 * __useCategoriaFaqQuery__
 *
 * To run a query within a React component, call `useCategoriaFaqQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriaFaqQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoriaFaqQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCategoriaFaqQuery(baseOptions: Apollo.QueryHookOptions<CategoriaFaqQuery, CategoriaFaqQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoriaFaqQuery, CategoriaFaqQueryVariables>(CategoriaFaqDocument, options);
      }
export function useCategoriaFaqLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoriaFaqQuery, CategoriaFaqQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoriaFaqQuery, CategoriaFaqQueryVariables>(CategoriaFaqDocument, options);
        }
export type CategoriaFaqQueryHookResult = ReturnType<typeof useCategoriaFaqQuery>;
export type CategoriaFaqLazyQueryHookResult = ReturnType<typeof useCategoriaFaqLazyQuery>;
export type CategoriaFaqQueryResult = Apollo.QueryResult<CategoriaFaqQuery, CategoriaFaqQueryVariables>;
export const FascicoliDocument = gql`
    query Fascicoli($offset: Int, $first: Int, $categoria_Slug_In: String, $titolo_Icontains: String, $orderBy: String) {
  fascicoli(
    offset: $offset
    first: $first
    categoria_Slug_In: $categoria_Slug_In
    titolo_Icontains: $titolo_Icontains
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        pk
        titolo
        descrizione
        edizione
        categoria {
          pk
          nome
        }
        tags {
          pk
          titolo
        }
        files {
          pk
          titolo
          url
        }
      }
    }
  }
}
    `;

/**
 * __useFascicoliQuery__
 *
 * To run a query within a React component, call `useFascicoliQuery` and pass it any options that fit your needs.
 * When your component renders, `useFascicoliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFascicoliQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *      categoria_Slug_In: // value for 'categoria_Slug_In'
 *      titolo_Icontains: // value for 'titolo_Icontains'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFascicoliQuery(baseOptions?: Apollo.QueryHookOptions<FascicoliQuery, FascicoliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FascicoliQuery, FascicoliQueryVariables>(FascicoliDocument, options);
      }
export function useFascicoliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FascicoliQuery, FascicoliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FascicoliQuery, FascicoliQueryVariables>(FascicoliDocument, options);
        }
export type FascicoliQueryHookResult = ReturnType<typeof useFascicoliQuery>;
export type FascicoliLazyQueryHookResult = ReturnType<typeof useFascicoliLazyQuery>;
export type FascicoliQueryResult = Apollo.QueryResult<FascicoliQuery, FascicoliQueryVariables>;
export const CategorieFascicoliDocument = gql`
    query categorieFascicoli {
  categorieFascicoli {
    edges {
      node {
        pk
        nome
        slug
        numFascicoli
      }
    }
  }
}
    `;

/**
 * __useCategorieFascicoliQuery__
 *
 * To run a query within a React component, call `useCategorieFascicoliQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieFascicoliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieFascicoliQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieFascicoliQuery(baseOptions?: Apollo.QueryHookOptions<CategorieFascicoliQuery, CategorieFascicoliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieFascicoliQuery, CategorieFascicoliQueryVariables>(CategorieFascicoliDocument, options);
      }
export function useCategorieFascicoliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieFascicoliQuery, CategorieFascicoliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieFascicoliQuery, CategorieFascicoliQueryVariables>(CategorieFascicoliDocument, options);
        }
export type CategorieFascicoliQueryHookResult = ReturnType<typeof useCategorieFascicoliQuery>;
export type CategorieFascicoliLazyQueryHookResult = ReturnType<typeof useCategorieFascicoliLazyQuery>;
export type CategorieFascicoliQueryResult = Apollo.QueryResult<CategorieFascicoliQuery, CategorieFascicoliQueryVariables>;
export const TipologieProprietaDocument = gql`
    query TipologieProprieta {
  tipologieProprieta {
    nome
    titolo
  }
}
    `;

/**
 * __useTipologieProprietaQuery__
 *
 * To run a query within a React component, call `useTipologieProprietaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipologieProprietaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipologieProprietaQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipologieProprietaQuery(baseOptions?: Apollo.QueryHookOptions<TipologieProprietaQuery, TipologieProprietaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TipologieProprietaQuery, TipologieProprietaQueryVariables>(TipologieProprietaDocument, options);
      }
export function useTipologieProprietaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TipologieProprietaQuery, TipologieProprietaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TipologieProprietaQuery, TipologieProprietaQueryVariables>(TipologieProprietaDocument, options);
        }
export type TipologieProprietaQueryHookResult = ReturnType<typeof useTipologieProprietaQuery>;
export type TipologieProprietaLazyQueryHookResult = ReturnType<typeof useTipologieProprietaLazyQuery>;
export type TipologieProprietaQueryResult = Apollo.QueryResult<TipologieProprietaQuery, TipologieProprietaQueryVariables>;
export const TipologieResidenzaDocument = gql`
    query TipologieResidenza {
  tipologieResidenza {
    nome
    titolo
  }
}
    `;

/**
 * __useTipologieResidenzaQuery__
 *
 * To run a query within a React component, call `useTipologieResidenzaQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipologieResidenzaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipologieResidenzaQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipologieResidenzaQuery(baseOptions?: Apollo.QueryHookOptions<TipologieResidenzaQuery, TipologieResidenzaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TipologieResidenzaQuery, TipologieResidenzaQueryVariables>(TipologieResidenzaDocument, options);
      }
export function useTipologieResidenzaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TipologieResidenzaQuery, TipologieResidenzaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TipologieResidenzaQuery, TipologieResidenzaQueryVariables>(TipologieResidenzaDocument, options);
        }
export type TipologieResidenzaQueryHookResult = ReturnType<typeof useTipologieResidenzaQuery>;
export type TipologieResidenzaLazyQueryHookResult = ReturnType<typeof useTipologieResidenzaLazyQuery>;
export type TipologieResidenzaQueryResult = Apollo.QueryResult<TipologieResidenzaQuery, TipologieResidenzaQueryVariables>;
export const TipologieAbitazioneDocument = gql`
    query TipologieAbitazione {
  tipologieAbitazione {
    nome
    titolo
  }
}
    `;

/**
 * __useTipologieAbitazioneQuery__
 *
 * To run a query within a React component, call `useTipologieAbitazioneQuery` and pass it any options that fit your needs.
 * When your component renders, `useTipologieAbitazioneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTipologieAbitazioneQuery({
 *   variables: {
 *   },
 * });
 */
export function useTipologieAbitazioneQuery(baseOptions?: Apollo.QueryHookOptions<TipologieAbitazioneQuery, TipologieAbitazioneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TipologieAbitazioneQuery, TipologieAbitazioneQueryVariables>(TipologieAbitazioneDocument, options);
      }
export function useTipologieAbitazioneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TipologieAbitazioneQuery, TipologieAbitazioneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TipologieAbitazioneQuery, TipologieAbitazioneQueryVariables>(TipologieAbitazioneDocument, options);
        }
export type TipologieAbitazioneQueryHookResult = ReturnType<typeof useTipologieAbitazioneQuery>;
export type TipologieAbitazioneLazyQueryHookResult = ReturnType<typeof useTipologieAbitazioneLazyQuery>;
export type TipologieAbitazioneQueryResult = Apollo.QueryResult<TipologieAbitazioneQuery, TipologieAbitazioneQueryVariables>;
export const QuotazioneFastQuoteCasaDocument = gql`
    query QuotazioneFastQuoteCasa($idQuotazione: String!, $siteId: Int, $hashKey: String) {
  quotazioneCasa(idQuotazione: $idQuotazione, siteId: $siteId, hashKey: $hashKey) {
    pk
    idQuotazione
    ndg
    codContratto
    dataDecorrenza
    nome
    cognome
    email
    completata
    isCliente
    errore
    cf
    telefono
    etaMassimaCane
    etaMinimaCane
    etaMinimaGatto
    etaMassimaGatto
    proprieta
    cap
    tipoResidenza
    tipoAbitazione
    piano
    metriQuadrati
    valArredamento
    altraCopMutuo
    consensoTrattamento
    animali {
      pk
      nome
      dataNascita
      tipo
    }
    garanzie {
      pk
      codice
      titolo
      descrizione
      descrizioneAggiuntiva
      icon
      file
      franchigiaDesc
      franchigia
      premioLordoAnnuo
      premioLordoMensile
      tipo
      massimale
      massimaleDesc
      keyMassimale
      children {
        pk
        codice
        titolo
        descrizione
        descrizioneAggiuntiva
        icon
        file
        franchigiaDesc
        franchigia
        premioLordoAnnuo
        premioLordoMensile
        tipo
        massimale
        massimaleDesc
        keyMassimale
      }
    }
    prodotto {
      pk
      contentTypeId
      slug
      titolo
    }
  }
}
    `;

/**
 * __useQuotazioneFastQuoteCasaQuery__
 *
 * To run a query within a React component, call `useQuotazioneFastQuoteCasaQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotazioneFastQuoteCasaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotazioneFastQuoteCasaQuery({
 *   variables: {
 *      idQuotazione: // value for 'idQuotazione'
 *      siteId: // value for 'siteId'
 *      hashKey: // value for 'hashKey'
 *   },
 * });
 */
export function useQuotazioneFastQuoteCasaQuery(baseOptions: Apollo.QueryHookOptions<QuotazioneFastQuoteCasaQuery, QuotazioneFastQuoteCasaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotazioneFastQuoteCasaQuery, QuotazioneFastQuoteCasaQueryVariables>(QuotazioneFastQuoteCasaDocument, options);
      }
export function useQuotazioneFastQuoteCasaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotazioneFastQuoteCasaQuery, QuotazioneFastQuoteCasaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotazioneFastQuoteCasaQuery, QuotazioneFastQuoteCasaQueryVariables>(QuotazioneFastQuoteCasaDocument, options);
        }
export type QuotazioneFastQuoteCasaQueryHookResult = ReturnType<typeof useQuotazioneFastQuoteCasaQuery>;
export type QuotazioneFastQuoteCasaLazyQueryHookResult = ReturnType<typeof useQuotazioneFastQuoteCasaLazyQuery>;
export type QuotazioneFastQuoteCasaQueryResult = Apollo.QueryResult<QuotazioneFastQuoteCasaQuery, QuotazioneFastQuoteCasaQueryVariables>;
export const GetPremioCasaFastDocument = gql`
    mutation getPremioCasaFast($input: GetPremioCasaFastInput!) {
  getPremioCasaFast(input: $input) {
    status
    message
    quotazione {
      idQuotazione
    }
  }
}
    `;
export type GetPremioCasaFastMutationFn = Apollo.MutationFunction<GetPremioCasaFastMutation, GetPremioCasaFastMutationVariables>;

/**
 * __useGetPremioCasaFastMutation__
 *
 * To run a mutation, you first call `useGetPremioCasaFastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPremioCasaFastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPremioCasaFastMutation, { data, loading, error }] = useGetPremioCasaFastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPremioCasaFastMutation(baseOptions?: Apollo.MutationHookOptions<GetPremioCasaFastMutation, GetPremioCasaFastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPremioCasaFastMutation, GetPremioCasaFastMutationVariables>(GetPremioCasaFastDocument, options);
      }
export type GetPremioCasaFastMutationHookResult = ReturnType<typeof useGetPremioCasaFastMutation>;
export type GetPremioCasaFastMutationResult = Apollo.MutationResult<GetPremioCasaFastMutation>;
export type GetPremioCasaFastMutationOptions = Apollo.BaseMutationOptions<GetPremioCasaFastMutation, GetPremioCasaFastMutationVariables>;
export const GetPremioCasaFastFullDetailDocument = gql`
    mutation getPremioCasaFastFullDetail($input: GetPremioCasaFastInput!) {
  getPremioCasaFast(input: $input) {
    status
    message
    quotazione {
      pk
      idQuotazione
      ndg
      codContratto
      dataDecorrenza
      nome
      cognome
      email
      completata
      isCliente
      errore
      cf
      telefono
      etaMassimaCane
      etaMinimaCane
      etaMinimaGatto
      etaMassimaGatto
      proprieta
      cap
      tipoResidenza
      tipoAbitazione
      piano
      metriQuadrati
      valArredamento
      altraCopMutuo
      consensoTrattamento
      animali {
        pk
        nome
        dataNascita
        tipo
      }
      garanzie {
        pk
        codice
        titolo
        descrizione
        descrizioneAggiuntiva
        icon
        file
        franchigiaDesc
        franchigia
        premioLordoAnnuo
        premioLordoMensile
        tipo
        massimale
        massimaleDesc
        keyMassimale
        children {
          pk
          codice
          titolo
          descrizione
          descrizioneAggiuntiva
          icon
          file
          franchigiaDesc
          franchigia
          premioLordoAnnuo
          premioLordoMensile
          tipo
          massimale
          massimaleDesc
          keyMassimale
        }
      }
      prodotto {
        pk
        contentTypeId
        slug
        titolo
      }
    }
  }
}
    `;
export type GetPremioCasaFastFullDetailMutationFn = Apollo.MutationFunction<GetPremioCasaFastFullDetailMutation, GetPremioCasaFastFullDetailMutationVariables>;

/**
 * __useGetPremioCasaFastFullDetailMutation__
 *
 * To run a mutation, you first call `useGetPremioCasaFastFullDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPremioCasaFastFullDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPremioCasaFastFullDetailMutation, { data, loading, error }] = useGetPremioCasaFastFullDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPremioCasaFastFullDetailMutation(baseOptions?: Apollo.MutationHookOptions<GetPremioCasaFastFullDetailMutation, GetPremioCasaFastFullDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPremioCasaFastFullDetailMutation, GetPremioCasaFastFullDetailMutationVariables>(GetPremioCasaFastFullDetailDocument, options);
      }
export type GetPremioCasaFastFullDetailMutationHookResult = ReturnType<typeof useGetPremioCasaFastFullDetailMutation>;
export type GetPremioCasaFastFullDetailMutationResult = Apollo.MutationResult<GetPremioCasaFastFullDetailMutation>;
export type GetPremioCasaFastFullDetailMutationOptions = Apollo.BaseMutationOptions<GetPremioCasaFastFullDetailMutation, GetPremioCasaFastFullDetailMutationVariables>;
export const SalvaTrasformaQuotazioneFastQuoteCasaDocument = gql`
    mutation SalvaTrasformaQuotazioneFastQuoteCasa($input: SalvaTrasformaQuotazioneCasaFastInput!) {
  salvaTrasformaQuotazioneCasaFast(input: $input) {
    status
    statusSalva
    message
    quotazione {
      idQuotazione
      ndg
      codContratto
      isCliente
    }
  }
}
    `;
export type SalvaTrasformaQuotazioneFastQuoteCasaMutationFn = Apollo.MutationFunction<SalvaTrasformaQuotazioneFastQuoteCasaMutation, SalvaTrasformaQuotazioneFastQuoteCasaMutationVariables>;

/**
 * __useSalvaTrasformaQuotazioneFastQuoteCasaMutation__
 *
 * To run a mutation, you first call `useSalvaTrasformaQuotazioneFastQuoteCasaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvaTrasformaQuotazioneFastQuoteCasaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvaTrasformaQuotazioneFastQuoteCasaMutation, { data, loading, error }] = useSalvaTrasformaQuotazioneFastQuoteCasaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvaTrasformaQuotazioneFastQuoteCasaMutation(baseOptions?: Apollo.MutationHookOptions<SalvaTrasformaQuotazioneFastQuoteCasaMutation, SalvaTrasformaQuotazioneFastQuoteCasaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalvaTrasformaQuotazioneFastQuoteCasaMutation, SalvaTrasformaQuotazioneFastQuoteCasaMutationVariables>(SalvaTrasformaQuotazioneFastQuoteCasaDocument, options);
      }
export type SalvaTrasformaQuotazioneFastQuoteCasaMutationHookResult = ReturnType<typeof useSalvaTrasformaQuotazioneFastQuoteCasaMutation>;
export type SalvaTrasformaQuotazioneFastQuoteCasaMutationResult = Apollo.MutationResult<SalvaTrasformaQuotazioneFastQuoteCasaMutation>;
export type SalvaTrasformaQuotazioneFastQuoteCasaMutationOptions = Apollo.BaseMutationOptions<SalvaTrasformaQuotazioneFastQuoteCasaMutation, SalvaTrasformaQuotazioneFastQuoteCasaMutationVariables>;
export const QuotazioneThankYouFastQuoteCasaDocument = gql`
    query QuotazioneThankYouFastQuoteCasa($idQuotazione: String!, $siteId: Int, $resetSession: Boolean!) {
  quotazioneCasa(
    idQuotazione: $idQuotazione
    siteId: $siteId
    resetSession: $resetSession
  ) {
    pk
    idQuotazione
    nome
    cognome
    email
    importoLordoAnnuo
    garanzieSelezionate {
      pk
      codice
      titolo
      importoLordoAnnuo
      tipo
    }
    prodotto {
      pk
      contentTypeId
      slug
      titolo
      prodottiCorrelati {
        edges {
          node {
            pk
            titolo
            descrizioneBreve
            mainImage
            previewImage
            url
            tags {
              pk
              titolo
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuotazioneThankYouFastQuoteCasaQuery__
 *
 * To run a query within a React component, call `useQuotazioneThankYouFastQuoteCasaQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotazioneThankYouFastQuoteCasaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotazioneThankYouFastQuoteCasaQuery({
 *   variables: {
 *      idQuotazione: // value for 'idQuotazione'
 *      siteId: // value for 'siteId'
 *      resetSession: // value for 'resetSession'
 *   },
 * });
 */
export function useQuotazioneThankYouFastQuoteCasaQuery(baseOptions: Apollo.QueryHookOptions<QuotazioneThankYouFastQuoteCasaQuery, QuotazioneThankYouFastQuoteCasaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotazioneThankYouFastQuoteCasaQuery, QuotazioneThankYouFastQuoteCasaQueryVariables>(QuotazioneThankYouFastQuoteCasaDocument, options);
      }
export function useQuotazioneThankYouFastQuoteCasaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotazioneThankYouFastQuoteCasaQuery, QuotazioneThankYouFastQuoteCasaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotazioneThankYouFastQuoteCasaQuery, QuotazioneThankYouFastQuoteCasaQueryVariables>(QuotazioneThankYouFastQuoteCasaDocument, options);
        }
export type QuotazioneThankYouFastQuoteCasaQueryHookResult = ReturnType<typeof useQuotazioneThankYouFastQuoteCasaQuery>;
export type QuotazioneThankYouFastQuoteCasaLazyQueryHookResult = ReturnType<typeof useQuotazioneThankYouFastQuoteCasaLazyQuery>;
export type QuotazioneThankYouFastQuoteCasaQueryResult = Apollo.QueryResult<QuotazioneThankYouFastQuoteCasaQuery, QuotazioneThankYouFastQuoteCasaQueryVariables>;
export const QuotazioneFastQuoteAutoDocument = gql`
    query QuotazioneFastQuoteAuto($idQuotazione: String!, $siteId: Int, $hashKey: String) {
  quotazioneAuto(idQuotazione: $idQuotazione, siteId: $siteId, hashKey: $hashKey) {
    pk
    idQuotazione
    ndg
    codContratto
    dataDecorrenza
    nome
    cognome
    email
    completata
    isCliente
    errore
    cf
    telefono
    targa
    dataNascita
    cap
    marcaAuto
    modelloAuto
    listaCap
    sistemaAdas
    antifurto
    tipoGuida
    massimaleRca
    massimaleCristalli
    scontoPacchettoPersona
    scontoPacchettoVeicolo
    scontoPacchettoEventi
    scontoPacchettoPersonaVeicolo
    scontoPacchettoVeicoloEventi
    scontoPacchettoPersonaEventi
    scontoPacchettoPersonaVeicoloEventi
    consensoTrattamento
    allestimentoCodice
    allestimentoDescrizione
    allestimentiAuto {
      codice
      descrizione
      selezionato
    }
    pacchetti {
      codice
      titolo
      descrizione
    }
    campiSistemaAdas {
      nome
      value
    }
    campiAntifurto {
      nome
      value
    }
    campiTipoGuida {
      nome
      value
    }
    garanzie {
      pk
      codice
      titolo
      descrizione
      descrizioneAggiuntiva
      icon
      file
      franchigiaDesc
      franchigia
      importoLordoAnnuo
      importoLordoAnnuoScontato
      statoIniziale
      massimale
      keyPremio
      garanzieAbbinate
      garanzieNecessariePacchettoVeicolo
      garanzieNecessariePacchettoPersona
      garanzieNecessariePacchettoEventi
      garanzieEscluse
      pacchetto {
        codice
        titolo
        descrizione
      }
      children {
        pk
        codice
        titolo
        descrizione
        descrizioneAggiuntiva
        icon
        file
        franchigiaDesc
        franchigia
        importoLordoAnnuo
        importoLordoAnnuoScontato
        statoIniziale
        massimale
        keyPremio
        garanzieAbbinate
        garanzieNecessariePacchettoVeicolo
        garanzieNecessariePacchettoPersona
        garanzieNecessariePacchettoEventi
        garanzieEscluse
        pacchetto {
          codice
          titolo
          descrizione
        }
      }
    }
    prodotto {
      pk
      contentTypeId
      slug
      titolo
    }
  }
}
    `;

/**
 * __useQuotazioneFastQuoteAutoQuery__
 *
 * To run a query within a React component, call `useQuotazioneFastQuoteAutoQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotazioneFastQuoteAutoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotazioneFastQuoteAutoQuery({
 *   variables: {
 *      idQuotazione: // value for 'idQuotazione'
 *      siteId: // value for 'siteId'
 *      hashKey: // value for 'hashKey'
 *   },
 * });
 */
export function useQuotazioneFastQuoteAutoQuery(baseOptions: Apollo.QueryHookOptions<QuotazioneFastQuoteAutoQuery, QuotazioneFastQuoteAutoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotazioneFastQuoteAutoQuery, QuotazioneFastQuoteAutoQueryVariables>(QuotazioneFastQuoteAutoDocument, options);
      }
export function useQuotazioneFastQuoteAutoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotazioneFastQuoteAutoQuery, QuotazioneFastQuoteAutoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotazioneFastQuoteAutoQuery, QuotazioneFastQuoteAutoQueryVariables>(QuotazioneFastQuoteAutoDocument, options);
        }
export type QuotazioneFastQuoteAutoQueryHookResult = ReturnType<typeof useQuotazioneFastQuoteAutoQuery>;
export type QuotazioneFastQuoteAutoLazyQueryHookResult = ReturnType<typeof useQuotazioneFastQuoteAutoLazyQuery>;
export type QuotazioneFastQuoteAutoQueryResult = Apollo.QueryResult<QuotazioneFastQuoteAutoQuery, QuotazioneFastQuoteAutoQueryVariables>;
export const QuotazioneThankYouFastQuoteAutoDocument = gql`
    query QuotazioneThankYouFastQuoteAuto($idQuotazione: String!, $siteId: Int, $resetSession: Boolean!) {
  quotazioneAuto(
    idQuotazione: $idQuotazione
    siteId: $siteId
    resetSession: $resetSession
  ) {
    pk
    idQuotazione
    nome
    cognome
    email
    importoLordoAnnuo
    importoLordoAnnuoScontato
    garanzieSelezionate {
      pk
      codice
      titolo
      importoLordoAnnuo
      importoLordoAnnuoScontato
      statoIniziale
      pacchetto {
        titolo
      }
    }
    prodotto {
      pk
      contentTypeId
      slug
      titolo
      prodottiCorrelati {
        edges {
          node {
            pk
            titolo
            descrizioneBreve
            mainImage
            previewImage
            url
            tags {
              pk
              titolo
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQuotazioneThankYouFastQuoteAutoQuery__
 *
 * To run a query within a React component, call `useQuotazioneThankYouFastQuoteAutoQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuotazioneThankYouFastQuoteAutoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuotazioneThankYouFastQuoteAutoQuery({
 *   variables: {
 *      idQuotazione: // value for 'idQuotazione'
 *      siteId: // value for 'siteId'
 *      resetSession: // value for 'resetSession'
 *   },
 * });
 */
export function useQuotazioneThankYouFastQuoteAutoQuery(baseOptions: Apollo.QueryHookOptions<QuotazioneThankYouFastQuoteAutoQuery, QuotazioneThankYouFastQuoteAutoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuotazioneThankYouFastQuoteAutoQuery, QuotazioneThankYouFastQuoteAutoQueryVariables>(QuotazioneThankYouFastQuoteAutoDocument, options);
      }
export function useQuotazioneThankYouFastQuoteAutoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuotazioneThankYouFastQuoteAutoQuery, QuotazioneThankYouFastQuoteAutoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuotazioneThankYouFastQuoteAutoQuery, QuotazioneThankYouFastQuoteAutoQueryVariables>(QuotazioneThankYouFastQuoteAutoDocument, options);
        }
export type QuotazioneThankYouFastQuoteAutoQueryHookResult = ReturnType<typeof useQuotazioneThankYouFastQuoteAutoQuery>;
export type QuotazioneThankYouFastQuoteAutoLazyQueryHookResult = ReturnType<typeof useQuotazioneThankYouFastQuoteAutoLazyQuery>;
export type QuotazioneThankYouFastQuoteAutoQueryResult = Apollo.QueryResult<QuotazioneThankYouFastQuoteAutoQuery, QuotazioneThankYouFastQuoteAutoQueryVariables>;
export const GetPremioAutoFastDocument = gql`
    mutation getPremioAutoFast($input: GetPremioAutoFastInput!) {
  getPremioAutoFast(input: $input) {
    status
    message
    inputError
    quotazione {
      idQuotazione
    }
  }
}
    `;
export type GetPremioAutoFastMutationFn = Apollo.MutationFunction<GetPremioAutoFastMutation, GetPremioAutoFastMutationVariables>;

/**
 * __useGetPremioAutoFastMutation__
 *
 * To run a mutation, you first call `useGetPremioAutoFastMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPremioAutoFastMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPremioAutoFastMutation, { data, loading, error }] = useGetPremioAutoFastMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPremioAutoFastMutation(baseOptions?: Apollo.MutationHookOptions<GetPremioAutoFastMutation, GetPremioAutoFastMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPremioAutoFastMutation, GetPremioAutoFastMutationVariables>(GetPremioAutoFastDocument, options);
      }
export type GetPremioAutoFastMutationHookResult = ReturnType<typeof useGetPremioAutoFastMutation>;
export type GetPremioAutoFastMutationResult = Apollo.MutationResult<GetPremioAutoFastMutation>;
export type GetPremioAutoFastMutationOptions = Apollo.BaseMutationOptions<GetPremioAutoFastMutation, GetPremioAutoFastMutationVariables>;
export const GetPremioAutoFastFullDetailDocument = gql`
    mutation getPremioAutoFastFullDetail($input: GetPremioAutoFastInput!) {
  getPremioAutoFast(input: $input) {
    status
    message
    inputError
    quotazione {
      pk
      idQuotazione
      ndg
      codContratto
      dataDecorrenza
      nome
      cognome
      email
      completata
      isCliente
      errore
      cf
      telefono
      targa
      dataNascita
      cap
      marcaAuto
      modelloAuto
      listaCap
      sistemaAdas
      antifurto
      tipoGuida
      massimaleRca
      massimaleCristalli
      scontoPacchettoPersona
      scontoPacchettoVeicolo
      scontoPacchettoEventi
      scontoPacchettoPersonaVeicolo
      scontoPacchettoVeicoloEventi
      scontoPacchettoPersonaEventi
      scontoPacchettoPersonaVeicoloEventi
      consensoTrattamento
      allestimentoCodice
      allestimentoDescrizione
      allestimentiAuto {
        codice
        descrizione
        selezionato
      }
      pacchetti {
        codice
        titolo
        descrizione
      }
      campiSistemaAdas {
        nome
        value
      }
      campiAntifurto {
        nome
        value
      }
      campiTipoGuida {
        nome
        value
      }
      garanzie {
        pk
        codice
        titolo
        descrizione
        descrizioneAggiuntiva
        icon
        file
        franchigiaDesc
        franchigia
        importoLordoAnnuo
        importoLordoAnnuoScontato
        statoIniziale
        massimale
        keyPremio
        garanzieAbbinate
        garanzieNecessariePacchettoVeicolo
        garanzieNecessariePacchettoPersona
        garanzieNecessariePacchettoEventi
        garanzieEscluse
        pacchetto {
          codice
          titolo
          descrizione
        }
        children {
          pk
          codice
          titolo
          descrizione
          descrizioneAggiuntiva
          icon
          file
          franchigiaDesc
          franchigia
          importoLordoAnnuo
          importoLordoAnnuoScontato
          statoIniziale
          massimale
          keyPremio
          garanzieAbbinate
          garanzieNecessariePacchettoVeicolo
          garanzieNecessariePacchettoPersona
          garanzieNecessariePacchettoEventi
          garanzieEscluse
          pacchetto {
            codice
            titolo
            descrizione
          }
        }
      }
      prodotto {
        pk
        contentTypeId
        slug
        titolo
      }
    }
  }
}
    `;
export type GetPremioAutoFastFullDetailMutationFn = Apollo.MutationFunction<GetPremioAutoFastFullDetailMutation, GetPremioAutoFastFullDetailMutationVariables>;

/**
 * __useGetPremioAutoFastFullDetailMutation__
 *
 * To run a mutation, you first call `useGetPremioAutoFastFullDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPremioAutoFastFullDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPremioAutoFastFullDetailMutation, { data, loading, error }] = useGetPremioAutoFastFullDetailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPremioAutoFastFullDetailMutation(baseOptions?: Apollo.MutationHookOptions<GetPremioAutoFastFullDetailMutation, GetPremioAutoFastFullDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPremioAutoFastFullDetailMutation, GetPremioAutoFastFullDetailMutationVariables>(GetPremioAutoFastFullDetailDocument, options);
      }
export type GetPremioAutoFastFullDetailMutationHookResult = ReturnType<typeof useGetPremioAutoFastFullDetailMutation>;
export type GetPremioAutoFastFullDetailMutationResult = Apollo.MutationResult<GetPremioAutoFastFullDetailMutation>;
export type GetPremioAutoFastFullDetailMutationOptions = Apollo.BaseMutationOptions<GetPremioAutoFastFullDetailMutation, GetPremioAutoFastFullDetailMutationVariables>;
export const SalvaTrasformaQuotazioneFastQuoteAutoDocument = gql`
    mutation SalvaTrasformaQuotazioneFastQuoteAuto($input: SalvaTrasformaQuotazioneAutoFastInput!) {
  salvaTrasformaQuotazioneAutoFast(input: $input) {
    status
    statusSalva
    message
    statusCode
    quotazione {
      idQuotazione
      ndg
      codContratto
      isCliente
    }
  }
}
    `;
export type SalvaTrasformaQuotazioneFastQuoteAutoMutationFn = Apollo.MutationFunction<SalvaTrasformaQuotazioneFastQuoteAutoMutation, SalvaTrasformaQuotazioneFastQuoteAutoMutationVariables>;

/**
 * __useSalvaTrasformaQuotazioneFastQuoteAutoMutation__
 *
 * To run a mutation, you first call `useSalvaTrasformaQuotazioneFastQuoteAutoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalvaTrasformaQuotazioneFastQuoteAutoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salvaTrasformaQuotazioneFastQuoteAutoMutation, { data, loading, error }] = useSalvaTrasformaQuotazioneFastQuoteAutoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalvaTrasformaQuotazioneFastQuoteAutoMutation(baseOptions?: Apollo.MutationHookOptions<SalvaTrasformaQuotazioneFastQuoteAutoMutation, SalvaTrasformaQuotazioneFastQuoteAutoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalvaTrasformaQuotazioneFastQuoteAutoMutation, SalvaTrasformaQuotazioneFastQuoteAutoMutationVariables>(SalvaTrasformaQuotazioneFastQuoteAutoDocument, options);
      }
export type SalvaTrasformaQuotazioneFastQuoteAutoMutationHookResult = ReturnType<typeof useSalvaTrasformaQuotazioneFastQuoteAutoMutation>;
export type SalvaTrasformaQuotazioneFastQuoteAutoMutationResult = Apollo.MutationResult<SalvaTrasformaQuotazioneFastQuoteAutoMutation>;
export type SalvaTrasformaQuotazioneFastQuoteAutoMutationOptions = Apollo.BaseMutationOptions<SalvaTrasformaQuotazioneFastQuoteAutoMutation, SalvaTrasformaQuotazioneFastQuoteAutoMutationVariables>;
export const CategorieFondoDocument = gql`
    query CategorieFondo {
  categorieFondo {
    edges {
      node {
        pk
        nome
        slug
      }
    }
  }
}
    `;

/**
 * __useCategorieFondoQuery__
 *
 * To run a query within a React component, call `useCategorieFondoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieFondoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieFondoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieFondoQuery(baseOptions?: Apollo.QueryHookOptions<CategorieFondoQuery, CategorieFondoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieFondoQuery, CategorieFondoQueryVariables>(CategorieFondoDocument, options);
      }
export function useCategorieFondoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieFondoQuery, CategorieFondoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieFondoQuery, CategorieFondoQueryVariables>(CategorieFondoDocument, options);
        }
export type CategorieFondoQueryHookResult = ReturnType<typeof useCategorieFondoQuery>;
export type CategorieFondoLazyQueryHookResult = ReturnType<typeof useCategorieFondoLazyQuery>;
export type CategorieFondoQueryResult = Apollo.QueryResult<CategorieFondoQuery, CategorieFondoQueryVariables>;
export const FondiDocument = gql`
    query Fondi($offset: Int, $first: Int, $descrizioneCompleta_Icontains: String, $categorie_Slug_Equals: String, $tipologia: String) {
  fondi(
    offset: $offset
    first: $first
    descrizioneCompleta_Icontains: $descrizioneCompleta_Icontains
    categorie_Slug_Equals: $categorie_Slug_Equals
    tipologia: $tipologia
  ) {
    totalCount
    edges {
      node {
        pk
        codiceFondo
        descrizioneCompleta
        codiceIsin
        tipologia
        prospettoUrl
        prospettoFile
        valoreQuota {
          valore
          data
          divisa
        }
      }
    }
  }
}
    `;

/**
 * __useFondiQuery__
 *
 * To run a query within a React component, call `useFondiQuery` and pass it any options that fit your needs.
 * When your component renders, `useFondiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFondiQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *      descrizioneCompleta_Icontains: // value for 'descrizioneCompleta_Icontains'
 *      categorie_Slug_Equals: // value for 'categorie_Slug_Equals'
 *      tipologia: // value for 'tipologia'
 *   },
 * });
 */
export function useFondiQuery(baseOptions?: Apollo.QueryHookOptions<FondiQuery, FondiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FondiQuery, FondiQueryVariables>(FondiDocument, options);
      }
export function useFondiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FondiQuery, FondiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FondiQuery, FondiQueryVariables>(FondiDocument, options);
        }
export type FondiQueryHookResult = ReturnType<typeof useFondiQuery>;
export type FondiLazyQueryHookResult = ReturnType<typeof useFondiLazyQuery>;
export type FondiQueryResult = Apollo.QueryResult<FondiQuery, FondiQueryVariables>;
export const PaginaDocument = gql`
    query Pagina($chiave: String, $path: String, $contentTypeId: Int, $objectId: Int, $preview: Boolean) {
  pagina(
    chiave: $chiave
    path: $path
    contentTypeId: $contentTypeId
    objectId: $objectId
    preview: $preview
  ) {
    pk
    nome
    titolo
    breadcrumbs {
      titolo
      url
    }
    seo {
      title
      description
      image
    }
    descrizione
    chiave
    contentTypeId
    mainImage
    previewImage
    visibile
    pubblicato
    visibilitaDal
    visibilitaAl
  }
}
    `;

/**
 * __usePaginaQuery__
 *
 * To run a query within a React component, call `usePaginaQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginaQuery({
 *   variables: {
 *      chiave: // value for 'chiave'
 *      path: // value for 'path'
 *      contentTypeId: // value for 'contentTypeId'
 *      objectId: // value for 'objectId'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function usePaginaQuery(baseOptions?: Apollo.QueryHookOptions<PaginaQuery, PaginaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaginaQuery, PaginaQueryVariables>(PaginaDocument, options);
      }
export function usePaginaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaginaQuery, PaginaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaginaQuery, PaginaQueryVariables>(PaginaDocument, options);
        }
export type PaginaQueryHookResult = ReturnType<typeof usePaginaQuery>;
export type PaginaLazyQueryHookResult = ReturnType<typeof usePaginaLazyQuery>;
export type PaginaQueryResult = Apollo.QueryResult<PaginaQuery, PaginaQueryVariables>;
export const PagineDocument = gql`
    query Pagine {
  pagine {
    edges {
      node {
        path
        tipologia
      }
    }
  }
}
    `;

/**
 * __usePagineQuery__
 *
 * To run a query within a React component, call `usePagineQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePagineQuery({
 *   variables: {
 *   },
 * });
 */
export function usePagineQuery(baseOptions?: Apollo.QueryHookOptions<PagineQuery, PagineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PagineQuery, PagineQueryVariables>(PagineDocument, options);
      }
export function usePagineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PagineQuery, PagineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PagineQuery, PagineQueryVariables>(PagineDocument, options);
        }
export type PagineQueryHookResult = ReturnType<typeof usePagineQuery>;
export type PagineLazyQueryHookResult = ReturnType<typeof usePagineLazyQuery>;
export type PagineQueryResult = Apollo.QueryResult<PagineQuery, PagineQueryVariables>;
export const ArticoloMagazineDocument = gql`
    query ArticoloMagazine($slug: String!, $preview: Boolean!) {
  articoloMagazine(slug: $slug, preview: $preview) {
    contentTypeId
    adminUrl
    modelClass
    pk
    title
    mainImage
    mainImageThumb
    publicationDate
    categoria {
      title
    }
    immagini {
      file
    }
    prev {
      url
    }
    next {
      url
    }
    correlati {
      pk
      title
      publicationDate
      abstract
      thumbnailSmall
      url
      categoria {
        title
      }
    }
    pagina {
      adminUrl
      breadcrumbs {
        titolo
        url
      }
      seo {
        title
        description
        image
      }
      chiave
    }
    visibile
  }
}
    `;

/**
 * __useArticoloMagazineQuery__
 *
 * To run a query within a React component, call `useArticoloMagazineQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticoloMagazineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticoloMagazineQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useArticoloMagazineQuery(baseOptions: Apollo.QueryHookOptions<ArticoloMagazineQuery, ArticoloMagazineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticoloMagazineQuery, ArticoloMagazineQueryVariables>(ArticoloMagazineDocument, options);
      }
export function useArticoloMagazineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticoloMagazineQuery, ArticoloMagazineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticoloMagazineQuery, ArticoloMagazineQueryVariables>(ArticoloMagazineDocument, options);
        }
export type ArticoloMagazineQueryHookResult = ReturnType<typeof useArticoloMagazineQuery>;
export type ArticoloMagazineLazyQueryHookResult = ReturnType<typeof useArticoloMagazineLazyQuery>;
export type ArticoloMagazineQueryResult = Apollo.QueryResult<ArticoloMagazineQuery, ArticoloMagazineQueryVariables>;
export const CategorieArticoliDocument = gql`
    query CategorieArticoli {
  categorieArticoli {
    edges {
      node {
        pk
        title
        slug
        numArticoli
      }
    }
  }
}
    `;

/**
 * __useCategorieArticoliQuery__
 *
 * To run a query within a React component, call `useCategorieArticoliQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategorieArticoliQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategorieArticoliQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategorieArticoliQuery(baseOptions?: Apollo.QueryHookOptions<CategorieArticoliQuery, CategorieArticoliQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategorieArticoliQuery, CategorieArticoliQueryVariables>(CategorieArticoliDocument, options);
      }
export function useCategorieArticoliLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategorieArticoliQuery, CategorieArticoliQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategorieArticoliQuery, CategorieArticoliQueryVariables>(CategorieArticoliDocument, options);
        }
export type CategorieArticoliQueryHookResult = ReturnType<typeof useCategorieArticoliQuery>;
export type CategorieArticoliLazyQueryHookResult = ReturnType<typeof useCategorieArticoliLazyQuery>;
export type CategorieArticoliQueryResult = Apollo.QueryResult<CategorieArticoliQuery, CategorieArticoliQueryVariables>;
export const ArticoliMagazineDocument = gql`
    query ArticoliMagazine($offset: Int, $first: Int, $categoria_Slug_In: String, $orderBy: String) {
  articoliMagazine(
    offset: $offset
    first: $first
    categoria_Slug_In: $categoria_Slug_In
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      hasNextPage
    }
    edges {
      node {
        slug
        pk
        title
        abstract
        mainImage
        url
        publicationDate
        categoria {
          title
        }
      }
    }
  }
}
    `;

/**
 * __useArticoliMagazineQuery__
 *
 * To run a query within a React component, call `useArticoliMagazineQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticoliMagazineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticoliMagazineQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      first: // value for 'first'
 *      categoria_Slug_In: // value for 'categoria_Slug_In'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useArticoliMagazineQuery(baseOptions?: Apollo.QueryHookOptions<ArticoliMagazineQuery, ArticoliMagazineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticoliMagazineQuery, ArticoliMagazineQueryVariables>(ArticoliMagazineDocument, options);
      }
export function useArticoliMagazineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticoliMagazineQuery, ArticoliMagazineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticoliMagazineQuery, ArticoliMagazineQueryVariables>(ArticoliMagazineDocument, options);
        }
export type ArticoliMagazineQueryHookResult = ReturnType<typeof useArticoliMagazineQuery>;
export type ArticoliMagazineLazyQueryHookResult = ReturnType<typeof useArticoliMagazineLazyQuery>;
export type ArticoliMagazineQueryResult = Apollo.QueryResult<ArticoliMagazineQuery, ArticoliMagazineQueryVariables>;
export const MagazineDocument = gql`
    query Magazine {
  articoliMagazine {
    edges {
      node {
        pk
        title
        publicationDate
        abstract
        thumbnailBig
        thumbnailSmall
        url
        categoria {
          title
        }
      }
    }
  }
  categorieArticoli {
    edges {
      node {
        title
        slug
      }
    }
  }
}
    `;

/**
 * __useMagazineQuery__
 *
 * To run a query within a React component, call `useMagazineQuery` and pass it any options that fit your needs.
 * When your component renders, `useMagazineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMagazineQuery({
 *   variables: {
 *   },
 * });
 */
export function useMagazineQuery(baseOptions?: Apollo.QueryHookOptions<MagazineQuery, MagazineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MagazineQuery, MagazineQueryVariables>(MagazineDocument, options);
      }
export function useMagazineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MagazineQuery, MagazineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MagazineQuery, MagazineQueryVariables>(MagazineDocument, options);
        }
export type MagazineQueryHookResult = ReturnType<typeof useMagazineQuery>;
export type MagazineLazyQueryHookResult = ReturnType<typeof useMagazineLazyQuery>;
export type MagazineQueryResult = Apollo.QueryResult<MagazineQuery, MagazineQueryVariables>;
export const MenuDocument = gql`
    query Menu {
  menuitems(parent_Isnull: true, attivo: true) {
    edges {
      node {
        id
        pk
        alias
        key
        attivo
        name
        mainImage
        mainImageResponsive
        url: finalUrl
        children(attivo: true) {
          edges {
            node {
              id
              pk
              alias
              key
              attivo
              name
              mainImage
              mainImageResponsive
              url: finalUrl
              children {
                edges {
                  node {
                    id
                    pk
                    alias
                    key
                    attivo
                    name
                    mainImage
                    mainImageResponsive
                    url: finalUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMenuQuery__
 *
 * To run a query within a React component, call `useMenuQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenuQuery({
 *   variables: {
 *   },
 * });
 */
export function useMenuQuery(baseOptions?: Apollo.QueryHookOptions<MenuQuery, MenuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenuQuery, MenuQueryVariables>(MenuDocument, options);
      }
export function useMenuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenuQuery, MenuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenuQuery, MenuQueryVariables>(MenuDocument, options);
        }
export type MenuQueryHookResult = ReturnType<typeof useMenuQuery>;
export type MenuLazyQueryHookResult = ReturnType<typeof useMenuLazyQuery>;
export type MenuQueryResult = Apollo.QueryResult<MenuQuery, MenuQueryVariables>;
export const CreateRichiestaPreventivatoreDocument = gql`
    mutation createRichiestaPreventivatore($input: RichiestaPreventivatoreInput!) {
  createRichiestaPreventivatore(input: $input) {
    status
  }
}
    `;
export type CreateRichiestaPreventivatoreMutationFn = Apollo.MutationFunction<CreateRichiestaPreventivatoreMutation, CreateRichiestaPreventivatoreMutationVariables>;

/**
 * __useCreateRichiestaPreventivatoreMutation__
 *
 * To run a mutation, you first call `useCreateRichiestaPreventivatoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRichiestaPreventivatoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRichiestaPreventivatoreMutation, { data, loading, error }] = useCreateRichiestaPreventivatoreMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRichiestaPreventivatoreMutation(baseOptions?: Apollo.MutationHookOptions<CreateRichiestaPreventivatoreMutation, CreateRichiestaPreventivatoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRichiestaPreventivatoreMutation, CreateRichiestaPreventivatoreMutationVariables>(CreateRichiestaPreventivatoreDocument, options);
      }
export type CreateRichiestaPreventivatoreMutationHookResult = ReturnType<typeof useCreateRichiestaPreventivatoreMutation>;
export type CreateRichiestaPreventivatoreMutationResult = Apollo.MutationResult<CreateRichiestaPreventivatoreMutation>;
export type CreateRichiestaPreventivatoreMutationOptions = Apollo.BaseMutationOptions<CreateRichiestaPreventivatoreMutation, CreateRichiestaPreventivatoreMutationVariables>;
export const ProdottoDocument = gql`
    query Prodotto($slug: String!, $preview: Boolean!) {
  prodotto(slug: $slug, preview: $preview) {
    pk
    contentTypeId
    url
    slug
    titolo
    descrizione
    descrizioneBreve
    mainImage
    previewImage
    adminUrl
    modelClass
    preventivatore
    icon
    sconto
    tags {
      pk
      titolo
    }
    linee {
      pk
      titolo
      description
      style
      label
      inPreventivatore
      icon
      descrizioneBreve
      prezzo
      garanzieIncluse {
        pk
        titolo
        style
        info
      }
      garanzieOpzionali {
        pk
        titolo
        style
        info
      }
    }
    faqs {
      pk
      domanda
      risposta
    }
    prodottiCorrelati {
      edges {
        node {
          pk
          titolo
          descrizioneBreve
          mainImage
          previewImage
          url
          tags {
            pk
            titolo
          }
        }
      }
    }
    pagina {
      titolo
      breadcrumbs {
        titolo
        url
      }
      seo {
        title
        description
        image
      }
      descrizione
      chiave
    }
    menuItems {
      pk
      alias
      key
      attivo
      style
      name
      mainImage
      mainImageResponsive
      description
      url: finalUrl
      ctaLabel
      blank
      children(attivo: true) {
        edges {
          node {
            pk
            alias
            key
            attivo
            style
            name
            mainImage
            mainImageResponsive
            description
            url: finalUrl
            ctaLabel
            blank
            children(attivo: true) {
              edges {
                node {
                  pk
                  alias
                  key
                  attivo
                  style
                  name
                  mainImage
                  mainImageResponsive
                  description
                  url: finalUrl
                  ctaLabel
                  blank
                  children(attivo: true) {
                    edges {
                      node {
                        pk
                        alias
                        key
                        attivo
                        style
                        name
                        mainImage
                        mainImageResponsive
                        description
                        url: finalUrl
                        ctaLabel
                        blank
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    pubblicato
    visibile
  }
}
    `;

/**
 * __useProdottoQuery__
 *
 * To run a query within a React component, call `useProdottoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottoQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useProdottoQuery(baseOptions: Apollo.QueryHookOptions<ProdottoQuery, ProdottoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottoQuery, ProdottoQueryVariables>(ProdottoDocument, options);
      }
export function useProdottoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottoQuery, ProdottoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottoQuery, ProdottoQueryVariables>(ProdottoDocument, options);
        }
export type ProdottoQueryHookResult = ReturnType<typeof useProdottoQuery>;
export type ProdottoLazyQueryHookResult = ReturnType<typeof useProdottoLazyQuery>;
export type ProdottoQueryResult = Apollo.QueryResult<ProdottoQuery, ProdottoQueryVariables>;
export const ProdottiDocument = gql`
    query Prodotti {
  prodotti {
    edges {
      node {
        slug
        categoria {
          slugTree
        }
      }
    }
  }
}
    `;

/**
 * __useProdottiQuery__
 *
 * To run a query within a React component, call `useProdottiQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottiQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottiQuery({
 *   variables: {
 *   },
 * });
 */
export function useProdottiQuery(baseOptions?: Apollo.QueryHookOptions<ProdottiQuery, ProdottiQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottiQuery, ProdottiQueryVariables>(ProdottiDocument, options);
      }
export function useProdottiLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottiQuery, ProdottiQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottiQuery, ProdottiQueryVariables>(ProdottiDocument, options);
        }
export type ProdottiQueryHookResult = ReturnType<typeof useProdottiQuery>;
export type ProdottiLazyQueryHookResult = ReturnType<typeof useProdottiLazyQuery>;
export type ProdottiQueryResult = Apollo.QueryResult<ProdottiQuery, ProdottiQueryVariables>;
export const ProdottiPreventivatoreDocument = gql`
    query ProdottiPreventivatore {
  prodottiPreventivatore {
    edges {
      node {
        pk
        contentTypeId
        url
        slug
        titolo
        descrizione
        descrizioneBreve
        preventivatore
        icon
        sconto
        linee {
          pk
          titolo
          description
          style
          label
          inPreventivatore
          icon
          descrizioneBreve
          prezzo
          garanzieIncluse {
            pk
            titolo
            style
            info
          }
          garanzieOpzionali {
            pk
            titolo
            style
            info
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProdottiPreventivatoreQuery__
 *
 * To run a query within a React component, call `useProdottiPreventivatoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useProdottiPreventivatoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProdottiPreventivatoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useProdottiPreventivatoreQuery(baseOptions?: Apollo.QueryHookOptions<ProdottiPreventivatoreQuery, ProdottiPreventivatoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProdottiPreventivatoreQuery, ProdottiPreventivatoreQueryVariables>(ProdottiPreventivatoreDocument, options);
      }
export function useProdottiPreventivatoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProdottiPreventivatoreQuery, ProdottiPreventivatoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProdottiPreventivatoreQuery, ProdottiPreventivatoreQueryVariables>(ProdottiPreventivatoreDocument, options);
        }
export type ProdottiPreventivatoreQueryHookResult = ReturnType<typeof useProdottiPreventivatoreQuery>;
export type ProdottiPreventivatoreLazyQueryHookResult = ReturnType<typeof useProdottiPreventivatoreLazyQuery>;
export type ProdottiPreventivatoreQueryResult = Apollo.QueryResult<ProdottiPreventivatoreQuery, ProdottiPreventivatoreQueryVariables>;
export const SearchDocument = gql`
    query Search($query: String!, $models: [Modello], $first: Int, $last: Int, $after: String, $before: String) {
  search(
    query: $query
    models: $models
    first: $first
    last: $last
    after: $after
    before: $before
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    count
    edges {
      node {
        object {
          ... on ArticoloMagazineNode {
            contentTypeId
            pk
            title
            abstract
            publicationDate
            categoria {
              title
            }
            mainImage
            thumbnailSmall
            url
          }
          ... on ProdottoNode {
            pk
            titolo
            mainImage
            previewImage
            url
            descrizioneBreve
            tags {
              pk
              titolo
            }
          }
          ... on CategoriaNode {
            pk
            nome
            titolo
            descrizione
            mainImage
            previewImage
            url
          }
          ... on FaqNode {
            pk
            domanda
            risposta
            url
            categoriaFaq: categoria {
              pk
              titolo
              slug
              descrizione
            }
          }
          ... on FascicoloNode {
            pk
            titolo
            edizione
            descrizione
            url
          }
          ... on PaginaNode {
            pk
            titolo
            descrizione
            url
          }
        }
        modelName
        score
        url
      }
    }
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      models: // value for 'models'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      after: // value for 'after'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    pk
    email
    nome
    cognome
    completed
    isStaff
    edit
    isImpersonate
    stopImpersonateUrl
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const CalcolaCodiceFiscaleDocument = gql`
    mutation CalcolaCodiceFiscale($input: CalcolaCodiceFiscaleInput!) {
  calcolaCodiceFiscale(input: $input) {
    status
    cf
  }
}
    `;
export type CalcolaCodiceFiscaleMutationFn = Apollo.MutationFunction<CalcolaCodiceFiscaleMutation, CalcolaCodiceFiscaleMutationVariables>;

/**
 * __useCalcolaCodiceFiscaleMutation__
 *
 * To run a mutation, you first call `useCalcolaCodiceFiscaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalcolaCodiceFiscaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calcolaCodiceFiscaleMutation, { data, loading, error }] = useCalcolaCodiceFiscaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalcolaCodiceFiscaleMutation(baseOptions?: Apollo.MutationHookOptions<CalcolaCodiceFiscaleMutation, CalcolaCodiceFiscaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalcolaCodiceFiscaleMutation, CalcolaCodiceFiscaleMutationVariables>(CalcolaCodiceFiscaleDocument, options);
      }
export type CalcolaCodiceFiscaleMutationHookResult = ReturnType<typeof useCalcolaCodiceFiscaleMutation>;
export type CalcolaCodiceFiscaleMutationResult = Apollo.MutationResult<CalcolaCodiceFiscaleMutation>;
export type CalcolaCodiceFiscaleMutationOptions = Apollo.BaseMutationOptions<CalcolaCodiceFiscaleMutation, CalcolaCodiceFiscaleMutationVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Node": [
      "ArticoloMagazineNode",
      "BoxCategoriaNode",
      "CategoriaArticoloNode",
      "CategoriaFaqNode",
      "CategoriaFascicoloNode",
      "CategoriaFondoNode",
      "CategoriaNode",
      "FaqNode",
      "FaqProdottoNode",
      "FascicoloFileNode",
      "FascicoloNode",
      "FondoCatalogoNode",
      "FondoFileNode",
      "FondoNode",
      "GaranziaLineaNode",
      "ImmagineMagazineNode",
      "LineaNode",
      "MenuItemNode",
      "PaginaNode",
      "ProdottoMenuItemNode",
      "ProdottoNode",
      "SearchType",
      "SocialNode",
      "TagFascicoloNode",
      "TagFondoNode",
      "TagProdottoNode",
      "TipologiaCampoCasaNode",
      "TipologiaContattoNode",
      "UtenteNode",
      "ValoreQuotaNode",
      "VideoMagazineNode"
    ],
    "SearchObject": [
      "ArticoloMagazineNode",
      "CategoriaNode",
      "FaqNode",
      "FascicoloNode",
      "PaginaNode",
      "ProdottoNode"
    ]
  }
};
      export default result;
    